<template>
  <div style="content-page">
    <div class="top" v-if="!isIframe"></div>
    <div class="content">
      <div class="model-content">
        <div class="tabs">
          <div class="tabs-item" v-for="(item, index) in tabsList" :key="index"
            :class="tabsIndex == index ? 'active' : ''" @click="changeTab(index)">
            {{ item.name }}
          </div>

          <div class="look">
            <span class="look-text" v-if="isShowLookContent == false" @click="isShowLookContent = true">查看演示</span>
            <span class="look-text" v-else @click="isShowLookContent = false">关闭</span>

            <div class="look-content" v-if="isShowLookContent">
              <div class="look-content-text">二维码</div>
              <qrcode :value="links" :options="{ size: 126 }" id="nfcPageUrlImage"></qrcode>
              <div class="look-content-btn">
                <div class="copy" @click="copy('nfcPageUrlText')">复制链接</div>
                <div class="download" @click="downCode('nfcPageUrlImage')">
                  下载二维码
                </div>
              </div>
              <div class="tips">链接用途：写入到NFC卡中。给用户碰一碰使用。</div>
            </div>
          </div>
        </div>

        <div style="display: flex">
          <!-- 模板1、2、3 -->
          <div class="first" v-if="tabsIndex == 0 || tabsIndex == 1 || tabsIndex == 2" :style="titleform.itemLogo && titleStyle == 1
              ? `
              background: url(${titleform.itemLogo}); 
              background-repeat: no-repeat; 
              background-position: center; 
              background-size: cover;
            `
              : 'background: radial-gradient(72.67% 37.85% at 11.666666666666666% 42.1875%, rgba(199, 218, 255, 1) 0%, rgba(242, 245, 255, 1) 100%)'
            ">
            <div class="title-box" @click="handleShow()">
              <div class="title" :style="`color:${titleform.fontColor}`">
                {{ titleform.itemTitle }}
              </div>
              <div class="subtitle" :style="`color:${titleform.fontColor}`">
                {{ titleform.itemSubtitle }}
              </div>
            </div>

            <div class="add-box">
              <img :src="shopForm.shopLogo" alt="" />
              <div class="font-text">
                <div class="font-text-1">{{ shopForm.shopName }}</div>
                <div class="font-text-2">{{ shopForm.shopNotice }}</div>
              </div>
            </div>

            <!-- 模板一 -->
            <div class="app-box-type-1" v-if="tabsIndex == 0">
              <div class="app-list">
                <div class="app-item" v-for="(item, index) in appList" :key="index" @click="handleEdit(item)">
                  <!-- ../assets/img/common/xhs.png -->
                  <img class="app-item-img" :src="item.itemLogo" alt="" />
                  <div class="app-item-text1">{{ item.itemTitle }}</div>
                  <div class="app-item-text2">{{ item.itemSubtitle }}</div>
                </div>
              </div>
              <div class="goods-list" v-if="goodsList.length > 0">
                <div class="goods-list-title" :style="{ color: goodsTitleColor }">
                  {{ goodsTitle }}
                </div>
                <div class="goods-list-item" v-for="(item, index) in goodsList" :key="index" @click="editGoods(item)">
                  <img class="goods-img" :src="item.itemLogo" alt="" srcset="" />
                  <div class="goods-info">
                    <div class="goods-info-title">{{ item.itemTitle }}</div>
                    <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                    <div class="goods-info-price">
                      <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                      <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                      <div class="goods-btn">抢购</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 模板二 -->
            <div class="app-box-type-2" v-else-if="tabsIndex == 1">
              <div class="app-list">
                <div class="app-item" v-for="(item, index) in appList" :key="index" @click="handleEdit(item)">
                  <img :src="item.itemLogo" alt="" />
                  <div>
                    <div class="app-item-text1">{{ item.itemTitle }}</div>
                    <div class="app-item-text2">{{ item.itemSubtitle }}</div>
                  </div>
                </div>
              </div>
              <div class="goods-list" v-if="goodsList.length > 0">
                <div class="goods-list-title" :style="{ color: goodsTitleColor }">
                  {{ goodsTitle }}
                </div>
                <div class="goods-list-item" v-for="(item, index) in goodsList" :key="index" @click="editGoods(item)">
                  <img class="goods-img" :src="item.itemLogo" alt="" srcset="" />
                  <div class="goods-info">
                    <div class="goods-info-title">{{ item.itemTitle }}</div>
                    <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                    <div class="goods-info-price">
                      <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                      <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                      <div class="goods-btn">抢购</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 模板三 -->
            <div class="app-box-type-3" v-else-if="tabsIndex == 2">
              <div v-for="(item, index) in modelList" :key="index">
                <div class="app-list" v-if="item.children.length > 0 && item.itemType != 200000">
                  <div class="app-title" :style="{ color: item.fontColor }">
                    {{ item.itemTitle }}
                  </div>
                  <div style="display: flex; flex-wrap: wrap">
                    <div class="app-item" v-for="(app, index2) in item.children" :key="index2" @click="handleEdit(app)">
                      <img class="app-item-img" :src="app.itemLogo" alt="" />
                      <div class="app-item-text">{{ app.itemTitle }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="goods-list" v-if="goodsList.length > 0">
                <div class="goods-list-title" :style="{ color: goodsTitleColor }">
                  {{ goodsTitle }}
                </div>
                <div class="goods-list-item" v-for="(item, index) in goodsList" :key="index" @click="editGoods(item)">
                  <img class="goods-img" :src="item.itemLogo" alt="" srcset="" />
                  <div class="goods-info">
                    <div class="goods-info-title">{{ item.itemTitle }}</div>
                    <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                    <div class="goods-info-price">
                      <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                      <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                      <div class="goods-btn">抢购</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 模板4 -->
          <div class="model4" v-if="tabsIndex == 3" :style="titleform.itemLogo && titleStyle == 1
              ? `
              background: url(${titleform.itemLogo}); 
              background-repeat: no-repeat; 
              background-position: center; 
              background-size: cover;
            `
              : 'background: radial-gradient(72.67% 37.85% at 11.666666666666666% 42.1875%, rgba(199, 218, 255, 1) 0%, rgba(242, 245, 255, 1) 100%)'
            ">
            <div class="model4-title" @click="handleShow()">
              <div class="title" :style="`color:${titleform.fontColor}`">
                {{ titleform.itemTitle }}
              </div>
              <div class="subtitle" :style="`color:${titleform.fontColor}`">
                {{ titleform.itemSubtitle }}
              </div>
              <div class="shop">
                <img class="shop-img" :src="shopForm.shopLogo" alt="" />
                <div class="shop-text">{{ shopForm.shopName }}</div>
              </div>
            </div>

            <div class="app-box-type-4">
              <div v-for="(item, index) in modelList" :key="index">
                <div class="app-list" v-if="item.children.length > 0 && item.itemType != 200000">
                  <div class="app-title" :style="{ color: item.fontColor }">
                    {{ item.itemTitle }}
                  </div>
                  <div style="display: flex; flex-wrap: wrap">
                    <div class="app-item" v-for="(app, index2) in item.children" :key="index2" @click="handleEdit(app)">
                      <img class="app-item-img" :src="app.itemLogo" alt="" />
                      <div class="app-item-text">{{ app.itemTitle }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="goods-list" v-if="goodsList.length > 0">
                <div class="goods-list-title" :style="{ color: goodsTitleColor }">
                  {{ goodsTitle }}
                </div>
                <div class="goods-list-item" v-for="(item, index) in goodsList" :key="index" @click="editGoods(item)">
                  <img class="goods-img" :src="item.itemLogo" alt="" srcset="" />
                  <div class="goods-info">
                    <div class="goods-info-title">{{ item.itemTitle }}</div>
                    <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                    <div class="goods-info-price">
                      <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                      <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                      <div class="goods-btn">抢购</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="model5" v-if="tabsIndex == 4" :style="titleform.itemLogo && titleStyle == 1
              ? `
              background: url(${titleform.itemLogo}); 
              background-repeat: no-repeat; 
              background-position: center; 
              background-size: cover;
            `
              : 'background: radial-gradient(72.67% 37.85% at 11.666666666666666% 42.1875%, rgba(199, 218, 255, 1) 0%, rgba(242, 245, 255, 1) 100%)'
            ">
            <div class="model5-title"
              :style="`background: url(${titleImgList[0].url}) no-repeat; background-size: cover;`"
              @click="handleShow()">
              <div class="title" :style="`color:${titleform.fontColor}`">
                {{ titleform.itemTitle }}
              </div>
              <div class="shop">
                <img class="shop-img" :src="shopForm.shopLogo" alt="" />
                <div class="shop-text" :style="`color:${titleform.fontColor}`">
                  {{ shopForm.shopName }}
                </div>
              </div>
            </div>

            <div class="app-box-type-5">
              <div class="four-img">
                <div class="four-img-box" v-for="(img, index) in fourImgList" :key="index"
                  @click="handleShowImg(index + 1)">
                  <div class="four-img-box-item" v-if="!img.url">
                    <i class="el-icon-plus"></i>
                  </div>
                  <img v-else class="four-img-box-img" :src="img.url" alt="" />
                </div>
              </div>

              <div v-for="(item, index) in modelList" :key="index">
                <div class="app-list" v-if="item.children.length > 0 && item.itemType != 200000">
                  <!-- <div class="app-title" :style="{ color: item.fontColor }">
                    {{ item.itemTitle }}
                  </div> -->
                  <div style="display: flex; flex-wrap: wrap">
                    <div class="app-item" v-for="(app, index2) in item.children" :key="index2" @click="handleEdit(app)">
                      <img class="app-item-img" :src="app.itemLogo" alt="" />
                      <div class="app-item-text">{{ app.itemTitle }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="three-img">
                <div class="three-img-top" @click="handleShowImg2(0)">
                  <img class="three-img-top-img" v-if="threeImgList[0].url" :src="threeImgList[0].url" alt="" />
                  <div class="three-img-top-box" v-else>
                    <i class="el-icon-plus" style="font-size: 40px"></i>
                  </div>
                </div>
                <div class="three-img-bottom">
                  <div class="i-box">
                    <div class="i-box-item" @click="handleShowImg2(1)">
                      <img class="i-box-item-img" v-if="threeImgList[1].url" :src="threeImgList[1].url" alt="" />
                      <div class="i-box-item-empty" v-else>
                        <i class="el-icon-plus" style="font-size: 20px"></i>
                      </div>
                    </div>
                    <div class="i-box-item" @click="handleShowImg2(2)">
                      <img class="i-box-item-img" v-if="threeImgList[2].url" :src="threeImgList[2].url" alt="" />
                      <div class="i-box-item-empty" v-else>
                        <i class="el-icon-plus" style="font-size: 20px"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="goods-list" v-if="goodsList.length > 0">
                <div class="goods-list-title" :style="{ color: goodsTitleColor }">
                  {{ goodsTitle }}
                </div>
                <div class="goods-list-item" v-for="(item, index) in goodsList" :key="index" @click="editGoods(item)">
                  <img class="goods-img" :src="item.itemLogo" alt="" srcset="" />
                  <div class="goods-info">
                    <div class="goods-info-title">{{ item.itemTitle }}</div>
                    <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                    <div class="goods-info-price">
                      <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                      <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                      <div class="goods-btn">抢购</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 标题设置 -->
          <transition name="el-zoom-in-top">
            <div class="title-set" v-if="isShowTitleSet">
              <div class="title-form">
                <div class="title-form-item">
                  <div class="title-form-item-left">背景图</div>
                  <div class="title-form-item-right">
                    <div class="option-item" :class="titleStyle == 0 ? 'active' : ''" @click="handleTitleStyle(0)">
                      默认
                    </div>
                    <div class="option-item" :class="titleStyle == 1 ? 'active' : ''" @click="handleTitleStyle(1)">
                      自定义
                    </div>
                  </div>
                </div>

                <div class="title-form-item" v-if="titleStyle == 1">
                  <div class="title-form-item-left">上传图片</div>
                  <div class="title-form-item-right">
                    <el-upload ref="upload" action="/ImageServer/YmUpload_image" list-type="picture-card"
                      :on-remove="handleRemove" :before-upload="beforeAvatarUpload" :http-request="handleSuccessImg"
                      :file-list="titleImg" accept=".JPG,.png,.jpeg" :limit="1" :class="{
                        hide: titleform.itemLogo,
                      }">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>

                <div class="title-form-item">
                  <div class="title-form-item-left">修改标题</div>
                  <div class="title-form-item-right">
                    <input type="text" v-model="titleform.itemTitle" placeholder="修改标题" maxlength="9" />
                  </div>
                </div>

                <div class="title-form-item">
                  <div class="title-form-item-left">副标题</div>
                  <div class="title-form-item-right">
                    <input type="text" v-model="titleform.itemSubtitle" placeholder="输入副标题" maxlength="12" />
                  </div>
                </div>

                <div class="title-form-item">
                  <div class="title-form-item-left">字体颜色</div>
                  <div class="title-form-item-right">
                    <div>
                      <div style="position: relative">
                        <input style="flex: 1" type="text" v-model="titleform.fontColor" placeholder="输入字体颜色" />
                        <div style="position: absolute; right: 0; top: -8px">
                          <el-color-picker v-model="titleform.fontColor" color-format="hex" />
                        </div>
                      </div>
                      <div class="tips">
                        格式：#000000为黑色,#FFFFFF为白色,未输入则默认使用黑色。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="title-set-save" @click="handleSave()">保存</div>
            </div>
          </transition>

          <!-- app设置 -->
          <transition name="el-zoom-in-top">
            <div class="app-set">
              <div>
                <div class="def-title">
                  <div>自定义</div>
                  <div class="add" @click="addApp(1, {})">
                    <img class="icon" src="../assets/img/common/add.png" alt="" />
                    <div class="add-text">添加</div>
                  </div>
                </div>
                <div class="app-set-title">已添加功能</div>
                <div class="list">
                  <div v-for="(item, index) in modelList" :key="index">
                    <div>
                      <div class="list-title">
                        <div>{{ item.itemTitle }}</div>
                        <img class="icon-edit" src="../assets/img/common/edit.png" alt="" @click="editCategory(item)" />
                        <img v-if="item.itemType != 200000" class="icon" src="../assets/img/common/reduce.png" alt=""
                          @click="deleteApp(item)" />
                      </div>
                      <div v-if="item.itemType === 100000" class="list-item" style="cursor: pointer"
                        @click="addApp(2, item)">
                        <img class="icon" src="../assets/img/common/add.png" alt="" />
                        <div class="add-text">添加自定义内容</div>
                      </div>
                      <div v-if="item.itemType === 200000" class="list-item" style="cursor: pointer"
                        @click="addApp(4, item)">
                        <img class="icon" src="../assets/img/common/add.png" alt="" />
                        <div class="add-text">添加自定义商品</div>
                      </div>
                      <div v-for="(item2, index2) in item.children" :key="index2">
                        <div class="list-item" @dragover.prevent
                          @drop="handleDrop(item.itemType, item.children, index2)" @dragend="handleDragEnd">
                          <img class="icon" src="../assets/img/common/reduce.png" alt="" @click="deleteApp(item2)" />

                          <div style="display: flex">
                            <img class="app-img" :src="item2.itemLogo" alt="" />
                            <div class="app-name">{{ item2.itemTitle }}</div>
                          </div>

                          <div class="move" draggable="true" @dragstart="handleDragStart(item.itemType, index2)">
                            <img class="move-img" src="../assets/img/common/move.png" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div class="app-set-title">可添加功能</div>
                <div class="list">
                  <div v-for="(item, index) in canAddList" :key="index">
                    <!-- v-if="item2.isShow" -->
                    <div class="list-item" v-if="item.isShow">
                      <img class="icon" src="../assets/img/common/add.png" alt="" @click="addApp(3, item)" />

                      <div style="display: flex">
                        <!-- ../assets/img/common/xhs.png -->
                        <img class="app-img" :src="item.imageUrl" alt="" />
                        <div>{{ item.typeName }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <!-- 分类设置 -->
          <transition name="el-zoom-in-top">
            <div class="child-set" v-if="isShowCategory">
              <div class="child-set-item">
                <div class="child-set-item-title">标题</div>
                <input type="text" placeholder="请输入标题" v-model="categoryForm.itemTitle" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">排序</div>
                <el-input-number v-model="categoryForm.indexNum" :min="1" :max="99" label="排序" :controls="false"
                  placeholder="1"></el-input-number>
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">字体颜色</div>
                <div class="child-set-item-right">
                  <div>
                    <div style="position: relative">
                      <input style="flex: 1" type="text" v-model="categoryForm.fontColor" placeholder="输入字体颜色" />
                      <div style="position: absolute; right: 0; top: -8px">
                        <el-color-picker v-model="categoryForm.fontColor" color-format="hex" />
                      </div>
                    </div>
                    <div class="tips">
                      格式：#000000为黑色,#FFFFFF为白色,未输入则默认使用黑色。
                    </div>
                  </div>
                </div>
              </div>

              <div class="child-set-save" @click="addSave(1)">保存</div>
            </div>
          </transition>

          <!-- 自定义项设置 -->
          <transition name="el-zoom-in-top">
            <div class="child-set" v-if="isShowZDYSet">
              <div class="child-set-item">
                <div class="child-set-item-title">图标</div>
                <el-upload ref="upload" action="/ImageServer/YmUpload_image" list-type="picture-card"
                  :on-remove="handleRemove1" :before-upload="beforeAvatarUpload" :http-request="handleSuccessImg1"
                  accept=".JPG,.png,.jpeg" :limit="1" :file-list="fileList" :class="{
                    hide: zdyform.itemLogo,
                  }">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">标题</div>
                <input type="text" placeholder="请输入标题" v-model="zdyform.itemTitle" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">副标题</div>
                <input type="text" placeholder="请输入副标题" v-model="zdyform.itemSubtitle" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">排序</div>
                <!-- <input type="text" placeholder="请输入1~99序号" minlength="1" maxlength="2"
                                    v-model="zdyform.indexNum"> -->
                <el-input-number v-model="zdyform.indexNum" :min="1" :max="99" label="排序" :controls="false"
                  placeholder="1"></el-input-number>
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">链接</div>
                <!-- <input type="text" placeholder="https://www.xxx.com" v-model="zdyform.outUrl"> -->
                <textarea class="child-set-dazhong-textarea" placeholder="https://www.xxx.com" v-model="zdyform.outUrl"
                  style="height: 50px"></textarea>
              </div>
              <div class="child-set-save" @click="addSave(2)">保存</div>
            </div>
          </transition>

          <!-- 商品设置 -->
          <transition name="el-zoom-in-top">
            <div class="child-set" v-if="isShowGoodsSet">
              <div class="child-set-item">
                <div class="child-set-item-title">图标</div>
                <el-upload ref="upload" action="/ImageServer/YmUpload_image" list-type="picture-card"
                  :on-remove="handleRemove2" :before-upload="beforeAvatarUpload" :http-request="handleSuccessImg2"
                  accept=".JPG,.png,.jpeg" :limit="1" :file-list="goodsImg" :class="{
                    hide: goodsform.itemLogo,
                  }">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">选择平台</div>
                <div>
                  <el-radio-group v-model="goodsform.platform">
                    <el-radio-button label="1">抖音</el-radio-button>
                    <el-radio-button label="2">大众</el-radio-button>
                    <el-radio-button label="3">美团</el-radio-button>
                  </el-radio-group>
                </div>
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">标题</div>
                <input type="text" placeholder="请输入标题" v-model="goodsform.itemTitle" :maxlength="9" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">副标题</div>
                <input type="text" placeholder="请输入副标题" v-model="goodsform.itemSubtitle" :maxlength="12" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">售价</div>
                <el-input-number v-model="goodsform.goodsPrice" :precision="2" :min="0.01"
                  :controls="false"></el-input-number>
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">原价</div>
                <el-input-number v-model="goodsform.goodsMarketPrice" :precision="2" :min="0.01"
                  :controls="false"></el-input-number>
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">排序</div>
                <el-input-number v-model="goodsform.indexNum" :min="1" :max="99" label="排序" :controls="false"
                  placeholder="1"></el-input-number>
              </div>

              <div class="child-set-dazhong" v-if="goodsform.platform == 1">
                <div class="child-set-dazhong-title">商品activeid</div>
                <textarea class="child-set-dazhong-textarea" placeholder="请输入商品activeid" v-model="goodsform.outUrl"
                  style="height: 50px"></textarea>
              </div>

              <div class="child-set-dazhong" v-else>
                <div class="child-set-dazhong-title">商品链接</div>
                <textarea class="child-set-dazhong-textarea" placeholder="请粘贴商品链接" v-model="goodsform.outUrl"
                  style="height: 50px"></textarea>
              </div>

              <div class="child-set-save" @click="addSave(4)">保存</div>
            </div>
          </transition>

          <!-- 子项设置 -->
          <transition name="el-zoom-in-top">
            <div class="child-set" v-if="isShowChildSet">
              <div class="child-set-item">
                <div class="child-set-item-title">标题</div>
                <input type="text" placeholder="请输入标题" v-model="addform.itemTitle" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">副标题</div>
                <input type="text" placeholder="请输入副标题" v-model="addform.itemSubtitle" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">排序</div>
                <el-input-number v-model="addform.indexNum" :min="1" :max="99" label="排序" :controls="false"
                  placeholder="1"></el-input-number>
              </div>

              <div class="pay-item" v-if="addform.itemType == 110010">
                <div class="pay-item-title">支付配置</div>
                <div class="pay-item-container">
                  <div class="pay-item-container-text">支持微信买单</div>
                  <div class="pay-item-container-btn" @click="handlePay(1)">去配置</div>
                </div>
              </div>
              <div class="pay-item" v-if="addform.itemType == 110020">
                <div class="pay-item-title">支付配置</div>
                <div class="pay-item-container">
                  <div class="pay-item-container-text">支持支付宝买单</div>
                  <div class="pay-item-container-btn" @click="handlePay(2)">去配置</div>
                </div>
              </div>
              <div class="pay-item" v-if="addform.itemType == 140010">
                <div class="pay-item-title">发视频</div>
                <div class="pay-item-container">
                  <div class="pay-item-container-text">支持抖音视频发布</div>
                  <div class="pay-item-container-btn" @click="linkToMarketingActivity">
                    去配置
                  </div>
                </div>
              </div>
              <div class="pay-item" v-if="addform.itemType == 140020">
                <div class="pay-item-title">发视频</div>
                <div class="pay-item-container">
                  <div class="pay-item-container-text">支持快手视频发布</div>
                  <div class="pay-item-container-btn" @click="linkToMarketingActivity">
                    去配置
                  </div>
                </div>
              </div>
              <div class="pay-item" v-if="addform.itemType == 140030">
                <div class="pay-item-title">发视频</div>
                <div class="pay-item-container">
                  <div class="pay-item-container-text">支持小红书视频发布</div>
                  <div class="pay-item-container-btn" @click="linkToMarketingActivity">
                    去配置
                  </div>
                </div>
              </div>
              <div class="pay-item" v-if="addform.itemType == 140040">
                <div class="pay-item-title">发视频</div>
                <div class="pay-item-container">
                  <div class="pay-item-container-text">支持视频号发布</div>
                  <div class="pay-item-container-btn" @click="linkToMarketingActivity">
                    去配置
                  </div>
                </div>
              </div>

              <div class="child-set-item" v-if="addform.itemType == 180030">
                <div class="child-set-item-title">微信二维码</div>
                <div>
                  <el-upload ref="upload" action="/ImageServer/YmUpload_image" list-type="picture-card"
                    :on-remove="handleRemove3" :before-upload="beforeAvatarUpload" :http-request="handleSuccessImg3"
                    accept=".JPG,.png,.jpeg" :limit="1" :file-list="wxImageList" :class="{
                      hide: addform.itemImage,
                    }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </div>

              <div class="child-set-item" v-if="
                addform.itemType == 160010 ||
                addform.itemType == 160020 ||
                addform.itemType == 160030 ||
                addform.itemType == 150010 ||
                addform.itemType == 150020 ||
                addform.itemType == 150030 ||
                addform.itemType == 150040 ||
                addform.itemType == 150050 ||
                addform.itemType == 150060 ||
                addform.itemType == 150070 ||
                addform.itemType == 140040
              ">
                <div class="child-set-item-title">资源活动</div>
                <div>
                  <el-select v-model="addform.shopActivityId" placeholder="请选择">
                    <el-option v-for="item in activeList" :key="item.activityId" :label="item.activityName"
                      :value="item.activityId">
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="child-set-item" v-if="addform.itemType == 150080 || addform.itemType == 170040">
                <div class="child-set-item-title">视频号ID</div>
                <input type="text" placeholder="请输入视频号ID" v-model="addform.sphId" />
              </div>

              <div class="child-set-item" v-if="addform.itemType == 150080">
                <div class="child-set-item-title">视频ID</div>
                <textarea type="text" placeholder="请输入视频ID" v-model="addform.sphVideoId"></textarea>
              </div>

              <div class="child-set-item" v-if="addform.itemType == 160020">
                <div class="child-set-item-title">文案标题</div>
                <input type="text" placeholder="请输入文案标题" v-model="addform.xhsItemTitle" />
              </div>

              <div class="child-set-dazhong" v-if="
                addform.itemType == 160010 ||
                addform.itemType == 160020 ||
                addform.itemType == 160030 ||
                addform.itemType == 150010 ||
                addform.itemType == 150020 ||
                addform.itemType == 150030 ||
                addform.itemType == 150040 ||
                addform.itemType == 150050 ||
                addform.itemType == 150060 ||
                addform.itemType == 150070 ||
                addform.itemType == 140040 ||
                addform.itemType == 140030
              ">
                <div class="child-set-dazhong-title">
                  <div class="text-box">
                    <div>资源文案</div>
                    <div class="switch-box">
                      <div>启用AI文案</div>
                      <el-switch v-model="addform.isEnableAi" :active-value="1" :inactive-value="0"
                        active-color="#409EFF" inactive-color="#909399">
                      </el-switch>
                    </div>
                  </div>
                </div>

                <div class="ai-condition" v-if="addform.isEnableAi">
                  <div class="ai-condition-item">
                    <div class="ai-condition-item-text">热销商品</div>
                    <div class="ai-condition-item-right">
                      <el-input placeholder="请输入热销商品" readonly v-model="addform.chatAihotSelling">
                        <el-button slot="append" icon="el-icon-edit" @click="editMenu = true"></el-button>
                      </el-input>
                    </div>
                  </div>
                  <div class="ai-condition-item">
                    <div class="ai-condition-item-text">文案字数</div>
                    <div class="ai-condition-item-right">
                      <el-select v-model="addform.chatAiContentMaxSize" placeholder="请选择文案字数">
                        <el-option v-for="item in fontNumberList" :key="item.number" :label="item.number"
                          :value="item.number">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="ai-condition-item">
                    <div class="ai-condition-item-text">文案风格</div>
                    <div class="ai-condition-item-right">
                      <el-select v-model="addform.chatAicopywritingTheme" placeholder="请选择文案风格">
                        <el-option v-for="item in styleList" :key="item.name" :label="item.name" :value="item.name">
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <div class="ai-condition-item">
                    <div class="ai-condition-item-text">文案要求</div>
                    <div class="ai-condition-item-right">
                      <el-input placeholder="请输入文案要求" v-model="addform.chatAiContentRequirement">
                      </el-input>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="default-title">
                    <span class="default-title-left">默认文案</span>
                    <!-- v-if="addform.isEnableAi && addform.ppCardItemId" -->
                    <div class="default-title-right" v-if="addform.isEnableAi" @click="createAIText()">
                      <img :class="{ rotate: isCreate }" src="../assets/img/common/refush.png" alt="" />
                      <span>生成文案</span>
                    </div>
                  </div>
                  <textarea class="child-set-dazhong-textarea" placeholder="请输入资源文案"
                    v-model="addform.chatAiContentAgent"></textarea>
                </div>
              </div>

              <!-- <div class="child-set-dazhong" v-if="addform.itemType == 150020">
                <div class="child-set-dazhong-title">
                  抖音店铺poiid
                </div>
                <textarea class="child-set-dazhong-textarea" placeholder="请输入抖音店铺poiid"
                  v-model="addform.outUrl"></textarea>
              </div> -->

              <div v-if="
                addform.itemType == 150010 ||
                addform.itemType == 150020 ||
                addform.itemType == 150030 ||
                addform.itemType == 150040 ||
                addform.itemType == 150050 ||
                addform.itemType == 150070 ||
                addform.itemType == 160030
              ">
                <div class="child-set-xiecheng">
                  <div class="child-set-xiecheng-text">poiid</div>
                  <div>
                    <el-input placeholder="请输入店铺poiid" v-model="addform.outPoiId"></el-input>
                  </div>
                </div>
                <div class="child-set-xiecheng">
                  <div class="child-set-xiecheng-text">poiName</div>
                  <div>
                    <el-input placeholder="请输入店铺poiName" v-model="addform.outPoiName"></el-input>
                  </div>
                </div>
              </div>

              <div v-if="addform.itemType == 150060">
                <div class="child-set-xiecheng">
                  <div class="child-set-xiecheng-text">hotelId</div>
                  <div>
                    <el-input placeholder="请输入店铺hotelId" v-model="addform.outPoiId"></el-input>
                  </div>
                </div>
              </div>

              <div v-if="addform.itemType == 150030">
                <div class="child-set-xiecheng">
                  <div class="child-set-xiecheng-text">位置</div>
                  <div class="child-set-xiecheng-location">
                    <el-input v-model="mapCenterInputText" placeholder="请填写经纬度" @blur="mapCenterInputTextBlur(addform)">
                      <template slot="append">
                        <el-button type="primary" @click="showDialogMap()">去获取</el-button>
                      </template>
                    </el-input>
                    <!-- <span class="key">{{ keyword }}</span>
                    <span class="btn" @click="showDialogMap">去定位</span> -->
                  </div>
                </div>
              </div>

              <div class="child-set-dazhong" v-if="
                addform.itemType == 150010 ||
                addform.itemType == 150040 ||
                addform.itemType == 150070 ||
                addform.itemType == 150090 ||
                addform.itemType == 170010 ||
                addform.itemType == 170020 ||
                addform.itemType == 170030 ||
                addform.itemType == 170050 ||
                addform.itemType == 190010 ||
                addform.itemType == 190020 ||
                addform.itemType == 190030
              ">
                <div class="child-set-dazhong-title" v-if="addform.itemType == 150010">
                  大众点评店铺
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 150040">
                  百度打卡
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 150070">
                  携程景区点评
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 150090">
                  百度百科网址
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 170010">
                  关注抖音账号
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 170020">
                  关注快手账号
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 170030">
                  关注小红书账号
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 170050">
                  关注公众号账号
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 190010">
                  抖音团购
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 190020">
                  美团团购
                </div>
                <div class="child-set-dazhong-title" v-if="addform.itemType == 190030">
                  大众点评团购
                </div>
                <textarea class="child-set-dazhong-textarea" placeholder="请粘贴平台主页链接"
                  v-model="addform.outUrl"></textarea>
              </div>

              <div class="child-set-save" @click="addSave(3)">保存</div>
            </div>
          </transition>

          <!-- wifi设置 -->
          <transition name="el-zoom-in-top">
            <div class="child-set" v-if="isShowWifiSet">
              <div class="child-set-item">
                <div class="child-set-item-title">wifi名称</div>
                <input type="text" placeholder="请输入名称" v-model="addform.wifiName" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">wifi密码</div>
                <input type="text" placeholder="请输入密码" v-model="addform.password" />
              </div>

              <div class="child-set-item">
                <div class="child-set-item-title">排序</div>
                <el-input-number v-model="addform.indexNum" :min="1" :max="99" label="排序" :controls="false"
                  placeholder="1"></el-input-number>
              </div>

              <div class="child-set-save" @click="addSave(3)">保存</div>
            </div>
          </transition>

          <transition name="el-zoom-in-top">
            <div class="img-set" v-if="isShowImgSet">
              <div class="img-form">
                <div>
                  <div class="img-form-item-left">标题背景图</div>
                  <div class="img-form-item-right">
                    <el-upload ref="upload" action="/ImageServer/YmUpload_image" list-type="picture-card" :on-remove="(file, fileList) => handleRemoveGroup(file, fileList, 1)
                      " :before-upload="beforeAvatarUpload" :http-request="(file) => handleSuccessGroup(file, 1)"
                      :file-list="group1Img" accept=".JPG,.png,.jpeg" :limit="1" :class="{
                        hide: group1Img.length == 1,
                      }">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                </div>

                <div>
                  <div>
                    <div class="img-form-item-left">
                      {{ `四拼图（当前位置：${currentSetImgIndex}）` }}
                    </div>
                    <div class="img-form-item-right">
                      <el-upload ref="upload" action="/ImageServer/YmUpload_image" list-type="picture-card" :on-remove="(file, fileList) => handleRemoveGroup(file, fileList, 2)
                        " :before-upload="beforeAvatarUpload" :http-request="(file) => handleSuccessGroup(file, 2)"
                        :file-list="group2Img" accept=".JPG,.png,.jpeg" :limit="1" :class="{
                          hide: group2Img.length == 1,
                        }">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                  </div>

                  <div>
                    <div class="img-form-item-left">外部链接</div>
                    <textarea class="img-form-textarea" placeholder="请粘贴平台主页链接"
                      v-model="fourImgList[currentSetImgIndex - 1].outUrl"></textarea>
                  </div>
                </div>
                <div class="child-set-apply" @click="saveImg()">应用</div>
              </div>
            </div>
          </transition>

          <transition name="el-zoom-in-top">
            <div class="img-set" v-if="isShowImgSet2">
              <div class="img-form">
                <div>
                  <div>
                    <div class="img-form-item-left">
                      {{ `三拼图（当前位置：${currentSetImgIndex2 + 1}）` }}
                    </div>
                    <div class="img-form-item-right">
                      <el-upload ref="upload" action="/ImageServer/YmUpload_image" list-type="picture-card" :on-remove="(file, fileList) => handleRemoveGroup(file, fileList, 3)
                        " :before-upload="beforeAvatarUpload" :http-request="(file) => handleSuccessGroup(file, 3)"
                        :file-list="group3Img" accept=".JPG,.png,.jpeg" :limit="1" :class="{
                          hide: group3Img.length == 1,
                        }">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                    <div>
                      <div class="img-form-item-left">外部链接</div>
                      <textarea class="img-form-textarea" placeholder="请粘贴平台主页链接"
                        v-model="threeImgList[currentSetImgIndex2].outUrl"></textarea>
                    </div>
                  </div>
                </div>
                <div class="child-set-apply" @click="saveImg2()">应用</div>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <!-- <div class="qrcode-content" v-if="links">
        <div>二维码</div>
        <qrcode :value="links" :options="{ size: 230 }" id="nfcPageUrlImage"> </qrcode>
        <div>链接</div>
        <span class="link">
          <input style="position: absolute; top: 0; left: 0; opacity: 0" :value="links" id="nfcPageUrlText" />
          {{ links }} &nbsp;
        </span>
        <div class="tip">链接用途：写入到NFC卡中。给用户碰一碰使用。</div>
        <div class="btn-list">
          <div class="copy" @click="copy('nfcPageUrlText')">复制链接</div>
          <div class="download" @click="downCode('nfcPageUrlImage')">下载二维码</div>
        </div>
      </div> -->
    </div>

    <el-dialog title="热销商品" :visible.sync="editMenu" width="30%">
      <div>
        <el-tag v-for="tag in addform.chatAiDishConfiguration" :key="tag.label" :type="tag.type" closable
          :disable-transitions="false" @click="addMenu(tag)" @close.prevent="handleClose(tag)">
          {{ tag.label }}
        </el-tag>
        <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
          @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 热销商品</el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="editMenu = false">取 消</el-button> -->
        <el-button type="primary" @click="editMenu = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 地图选择 -->
    <el-dialog width="510px" :visible.sync="dialogMapVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true">
      <div slot="title" class="dialog-title">地图定位</div>
      <!-- <baidu-map
        v-if="dialogMapVisible"
        class="map"
        :center="center"
        :zoom="zoom"
        @ready="mapReadyHandler"
        @click="getPoint"
        :scroll-wheel-zoom="true"
      >
        <bm-control :offset="{ width: '10px', height: '10px' }">
          <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
        </bm-control>
        <bm-local-search
          :keyword="keyword"
          :auto-viewport="true"
          :location="location"
          zoom="12.8"
          style="display: none"
        ></bm-local-search>
        <bm-marker :position="postionMap">
          <bm-info-window
            :show="show"
            @close="infoWindowClose"
            @open="infoWindowOpen"
            style="font-size: 14px"
          >
            <p>站点：{{ add.siteName }}</p>
            <p>站点地址：{{ add.site }}</p>
          </bm-info-window>
        </bm-marker>
      </baidu-map> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogMapVisible = false">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：Api，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》'
import {
  uploadVideo,
  uploadImg,
  modifyShopInfo,
  uploadFile,
  getShopInfo,
  addOrUpdatePpCardItem,
  findPpCardltems,
  delPpCardId,
  findPpCardItemType,
  updatePpCardIdIndex,
  Marketing_activityList,
  getActivityListTotalNum,
  apiCreateAiText,
  singleDrawWork,
} from "@/api/index.js";
import { mapState, mapActions } from "vuex";
import qrcode from "@xkeshi/vue-qrcode";
import { gg2bd, bd2gg } from "@/utils/map.js";
import { commonFuc } from "@/mixins/commonFuc";
import { file } from "jszip";

let loading = null;

export default {
  mixins: [commonFuc],
  components: {
    qrcode,
  },
  props: [],
  data() {
    return {
      tabsIndex: 0, // 模板索引
      tabsList: [
        {
          name: "模板一",
        },
        {
          name: "模板二",
        },
        {
          name: "模板三",
        },
        {
          name: "模板四",
        },
        {
          name: "模板五",
        },
      ],
      fontNumberList: [
        {
          number: "50",
        },
        {
          number: "100",
        },
        {
          number: "200",
        },
        {
          number: "500",
        },
      ],
      styleList: [
        {
          name: "娱乐风格",
        },
        {
          name: "新闻风格",
        },
        {
          name: "中式风格",
        },
        {
          name: "市井风",
        },
        {
          name: "轻奢风",
        },
        {
          name: "美式风格",
        },
        {
          name: "探店风格",
        },
      ],

      queryInfo: {
        pageNo: 1,
        row: 100,
      },
      total: 0,
      activeList: [],

      links: "",

      // 地图相关
      dialogMapVisible: false,
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
      showMap: false,

      isShowTitleSet: false,
      titleform: {
        itemType: 1000,
        itemTitle: "碰一碰·领福利",
        itemSubtitle: "点击立即参与，好礼等你拿",
        fontColor: "#000000",
        itemImages: "",
        itemLogo: "",
        templateType: 1,
      },
      titleStyle: 0, // 0:默认 1:自定义

      // 已添加列表
      appList: [],
      draggingIndex: null,

      shopForm: {
        dianpingUrl: "",
        gdShareUrl: "",
        dyShopShareUrl: "",
        nfcBdmPageUrl: "",
      },

      modelList: [],
      model3List: [],
      canAddList: [],

      // 自定义类目
      isShowCategory: false,
      categoryForm: {
        itemType: 100000,
        itemTitle: "",
        indexNum: "",
        fontColor: "#000000",
      },

      // 自定义模块
      zdyform: {
        itemLogo: "",
        itemTitle: "",
        itemSubtitle: "",
        outUrl: "",
        indexNum: 0,
      },
      isShowZDYSet: false,

      // 添加编辑模块
      addform: {
        itemType: "",
        itemTitle: "",
        itemSubtitle: "",
        itemImage: "", //微信二维码
        outUrl: "", //大众点评才有
        shopActivityId: "",
        xhsItemTitle: "", //小红书标题

        sphId: "",
        sphVideoId: "",

        shopName: "",
        shopAddress: "",
        shopCategory: "",
        chatAiContentAgent: "",

        // 是否启用AI文案
        isEnableAi: 0,
        aiType: "",
        chatAihotSelling: "",
        chatAiContentMaxSize: "",
        chatAicopywritingTheme: "",
        chatAiContentRequirement: "",
        chatAiDishConfiguration: [],

        indexNum: 0,
        wifiName: "",
        password: "",

        outPoiId: "",
        outPoiName: "",
        outShopId: "",
        outShopName: "",

        lat: "",
        lon: "",
      },
      isShowChildSet: false,

      isUploadImage: false,

      fileList: [],
      titleImg: [],
      goodsImg: [],
      wxImageList: [],

      // 商品模块
      goodsform: {
        platform: "1",
        itemLogo: "",
        itemTitle: "",
        itemSubtitle: "",
        outUrl: "",
        indexNum: 0,
      },
      goodsList: [],
      goodsTitle: "",
      goodsTitleColor: "#000000",

      isShowGoodsSet: false,

      isShowWifiSet: false,
      parentOrigin: "",

      isShowLookContent: false,
      currentApp: null,
      DSQ: null,
      isCreate: false,

      editMenu: false,
      inputVisible: false,
      inputValue: "",

      isSaving: false,

      isShowImgSet: false,
      isShowImgSet2: false,
      currentSetImgIndex: 0,
      currentSetImgIndex2: 0,
      titleImgList: [
        {
          url: "",
        },
      ],
      // 初始四拼图数组
      fourImgList: [
        {
          url: "",
          outUrl: "",
        },
        {
          url: "",
          outUrl: "",
        },
        {
          url: "",
          outUrl: "",
        },
        {
          url: "",
          outUrl: "",
        },
      ],
      // 初始三拼图数组
      threeImgList: [
        {
          url: "",
          outUrl: "",
        },
        {
          url: "",
          outUrl: "",
        },
        {
          url: "",
          outUrl: "",
        },
      ],
      group1Img: [],
      group2Img: [],
      group3Img: [],
      imagesObject: {},
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    isIframe() {
      return this.$route.path.indexOf("touchDrainageCardNewIframe") != -1;
    },
    backgroundStyle() {
      if (this.titleImgList && this.titleImgList.length > 0 && this.titleImgList[0].url) {
        return `background: url(${this.titleImgList[0].url}) no-repeat; background-size: cover;`;
      }
      return ""; // 或者返回默认背景样式
    },
  },
  watch: {
    "addform.chatAiDishConfiguration": {
      handler(newVal) {
        if (!Array.isArray(newVal)) {
          this.addform.chatAihotSelling = "";
          return;
        }

        // 筛选出 type 为 success 的项，并将它们的 label 以逗号形式拼接
        this.addform.chatAihotSelling = newVal
          .filter((item) => item.type === "success")
          .map((item) => item.label)
          .join(",");
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.isIframe) {
      // 监听父页面的回复
      window.addEventListener("message", async (event) => {
        if (event.origin != location.origin) {
          this.parentOrigin = event.origin;
        }
        // ✅ 校验来源
        if (event.origin !== this.parentOrigin) return;
        console.log("👂 收到父页面回复：", event.data, event.origin);
        if (event.data.type == "activeList") {
          this.activeList = event.data.data;
        } else if (event.data.type == "shopInfo") {
          Object.assign(this.shopForm, event.data.data);
        } else if (event.data.type == "model3List") {
          this.handleModel3ListData(event.data.data);
        } else if (event.data.type == "modelList") {
          this.handleModelList(event.data.data);
        } else if (event.data.type == "addSave1") {
          this.handleAddSave1();
        } else if (event.data.type == "addSave2") {
          this.handleAddSave2();
        } else if (event.data.type == "addSave3") {
          this.handleAddSave3();
        } else if (event.data.type == "addSave4") {
          this.handleAddSave4();
        } else if (event.data.type == "changeTab") {
          this.tabsIndex = event.data.params;
          this.isSaving = false;
          loading.close();
        } else if (event.data.type == "searchResult") {
          await this.searchResult(event.data.drawWorkId);
        } else if (event.data.type == "singleDrawWorkRes") {
          if (
            event.data.resData.workResultStatus == 200 ||
            event.data.resData.workResultStatus == 300
          ) {
            this.DSQ && clearInterval(this.DSQ);
            this.addform.chatAiContentAgent = event.data.resData.workText;

            this.isCreate = false;
          } else if (event.data.resData.workResultStatus == 199) {
            this.DSQ && clearInterval(this.DSQ);
            this.$message.error(event.data.resData.workResultMsg);

            this.isCreate = false;
          }
        }
        this.sendToParent({
          type: "aaa",
          data: "收到",
        });
      });
    } else {
      this.getMarketing_activityList();

      await getShopInfo().then((shopInfo) => {
        Object.assign(this.shopForm, shopInfo.data);
      });
      // this.links = `${window.location.origin}/#/pypView?shopId=${10000}`

      await this.getModel3List();
      await this.getModelList();
    }
  },
  methods: {
    ...mapActions(["changeAppltType"]),
    sendToParent(msg) {
      // 向父页面发送消息
      window.parent.postMessage(msg, this.parentOrigin);
    },
    handlePay(params) {
      if (params == 1) {
        this.changeAppltType("wx");
      } else {
        this.changeAppltType("TINYAPP");
      }
      if (this.isIframe) {
        this.sendToParent({
          type: "handlePay",
        });
      } else {
        this.$router.push({
          path: "/applt",
        });
      }
    },
    linkToMarketingActivity() {
      if (this.isIframe) {
        this.sendToParent({
          type: "linkToMarketingActivity",
        });
      } else {
        this.$router.push({
          path: "/marketingActivity",
        });
      }
    },
    copy(name) {
      // var copyText = document.getElementById(name);
      // copyText.select();
      // document.execCommand("copy");
      const el = document.createElement("textarea");
      el.value = this.links;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    downCode(name) {
      let canvas = document.getElementById(name);
      let dataURL = canvas.toDataURL("image/png");
      let a = document.createElement("a"); // 创建一个a节点插入的document
      let event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = `${name}.png`; // 设置a节点的download属性值
      a.href = dataURL; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event);
    },
    mapReadyHandler({ BMap, map }) {
      this.center = {
        lng: this.shopForm.longitude || 116.41,
        lat: this.shopForm.latitude || 39.9,
      };
      this.zoom = 12.8;
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    getPoint(e) {
      console.log("e", e);
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.addform.lon = lng;
        this.addform.lat = lat;
      });
    },

    // 生成AI文案
    async createAIText() {
      if (this.isCreate) {
        this.$message.error("请等待生成文案");
        return;
      }

      if (!this.addform.chatAihotSelling) {
        this.$message.error("请输入热销商品");
        return;
      }

      if (!this.addform.chatAiContentMaxSize) {
        this.$message.error("请选择文案字数");
        return;
      }

      if (!this.addform.chatAicopywritingTheme) {
        this.$message.error("请选择文案风格");
        return;
      }
      // const temp = {
      //   150010: '大众点评',
      //   150020: '抖音',
      //   150030: '高德',
      //   150050: '美团',
      //   150040: '百度',
      //   150060: '携程点评',
      //   150070: '携程景区点评',
      //   160010: '朋友圈',
      //   160020: '小红书',
      //   160030: '携程发布图文'
      // }
      // this.addform.aiType = temp[this.currentApp.itemType];
      try {
        const httpData = {
          ppCardItemId: this.currentApp.ppCardItemId,
          shopName: this.shopForm.shopName,
          shopAddress: this.shopForm.shopAddress,
          chatAiContentMaxSize: this.addform.chatAiContentMaxSize,
          chatAicopywritingTheme: this.addform.chatAicopywritingTheme,
          chatAiContentRequirement: this.addform.chatAiContentRequirement,
          chatAihotSelling: this.addform.chatAihotSelling,
          // aiType: this.addform.aiType || this.addform.typeName,
          itemType: this.addform.itemType,
          llmModelDrawStyleId: 17642,
        };
        if (this.isIframe) {
          this.sendToParent({
            type: "apiCreateAiText",
            data: Object.assign(httpData, {
              notifyType: "searchResult",
            }),
          });
        } else {
          const res = await apiCreateAiText(httpData);
          if (res.code == 1) {
            await this.searchResult(res.data.drawWorkId);
          } else {
            this.$message.error(res.msg);
          }
        }
      } catch (error) {
        console.log(error);
        this.$message.error(error);
      }
    },
    // 轮询结果
    async searchResult(id) {
      this.isCreate = true;
      this.DSQ = setInterval(async () => {
        try {
          if (this.isIframe) {
            this.sendToParent({
              type: "singleDrawWork",
              data: Object.assign({
                drawWorkId: id,
                notifyType: "singleDrawWorkRes",
              }),
            });
          } else {
            const res = await singleDrawWork({ drawWorkId: id });
            if (res.data.workResultStatus == 200 || res.data.workResultStatus == 300) {
              this.DSQ && clearInterval(this.DSQ);
              this.addform.chatAiContentAgent = res.data.workText;

              this.isCreate = false;
            } else if (res.data.workResultStatus == 199) {
              this.DSQ && clearInterval(this.DSQ);
              this.$message.error(res.data.workResultMsg);

              this.isCreate = false;
            }
          }
        } catch (error) {
          this.isCreate = false;
          this.DSQ && clearInterval(this.DSQ);
          this.$message.error(error);
        }
      }, 5000);
    },
    handleTitleStyle(params) {
      this.titleStyle = params;
      if (this.titleStyle == 1 && this.titleform.itemLogo) {
        this.titleImg = [{ name: "", url: this.titleform.itemLogo }];
      }
    },
    getMarketing_activityList(timeStatus) {
      Marketing_activityList({
        activityType: 101,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        timeStatus: 2,
      }).then((res) => {
        getActivityListTotalNum({
          activityType: 5,
          pageNo: this.queryInfo.pageNo,
          row: this.queryInfo.row,
          timeStatus: 2,
        }).then((res) => {
          if (res.code == 1) {
            this.total = res.data.totalNum;
          } else {
            this.total = 0;
          }
        });
        if (res.code == 1) {
          this.activeList = res.data;
        } else if (res.code == -1) {
          this.activeList = [];
        } else {
        }
      });
    },

    // 获取系统配置
    async getModel3List() {
      try {
        const res = await findPpCardItemType();
        if (res.code == 1) {
          this.handleModel3ListData(res);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    handleModel3ListData(res) {
      this.model3List = res.data[0].children || [];

      this.canAddList = [];
      this.model3List.forEach((item) => {
        item.children.forEach((child) => {
          if (child.type != 150040) {
            this.canAddList.push({
              imageUrl: child.imageUrl,
              level: child.level,
              type: child.type,
              typeName: child.typeName,
              isShow: true,
              parentType: item.type,
            });
          }
        });
      });
    },
    // 获取用户默认配置
    async getModelList() {
      try {
        console.log("初始tabsIndex", this.tabsIndex);
        const res = await findPpCardltems({ pageSize: 9999 });
        if (res.code == 1) {
          this.handleModelList(res);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    handleModelList(res) {
      this.links = res.data.list.length ? res.data.list[0].pypCardCode : "";
      this.modelList = res.data.list.length ? res.data.list[0].children : [];
      this.titleStyle = res.data.list.length && res.data.list[0].itemLogo ? 1 : 0;
      this.imagesObject =
        res.data.list.length && res.data.list[0].cateringPosterTemp
          ? JSON.parse(res.data.list[0].cateringPosterTemp)
          : [];
      // 将对象中的字段 赋值给 fourImgList threeImgList titleImgList
      if (this.imagesObject.titleImgList) {
        this.titleImgList = this.imagesObject.titleImgList;
        this.fourImgList = this.imagesObject.fourImgList;
        this.threeImgList = this.imagesObject.threeImgList;
      }

      this.titleform = res.data.list.length
        ? Object.assign(this.titleform, res.data.list[0])
        : {
          itemType: 1000,
          itemTitle: "碰一碰·领福利",
          itemSubtitle: "点击立即参与，好礼等你拿",
          fontColor: "#000000",
          itemLogo: "",
          itemImages: "",
          templateType: 1,
        };
      console.log("templateType", this.titleform.templateType);
      this.tabsIndex = this.titleform.templateType - 1;
      console.log("修改后tabsIndex", this.tabsIndex);

      if (this.titleform.itemLogo) {
        this.titleImg = [{ name: "", url: this.titleform.itemLogo }];
      }
      if (!this.titleform.fontColor) {
        this.titleform.fontColor = "#000000";
      }

      this.appList = [];
      this.goodsList = [];
      this.modelList.forEach((item) => {
        if (item.itemType == 200000) {
          this.goodsTitle = item.itemTitle;
          this.goodsTitleColor = item.fontColor;
        }

        item.children.forEach((child) => {
          this.canAddList.forEach((el) => {
            if (el.type == child.itemType) {
              el.isShow = false;
            }
          });

          if (child.itemType != 200010) {
            this.appList.push(child);
          } else {
            this.goodsList.push(child);
          }
        });
      });
    },
    // 添加APP配置 type:1分类，2自定义类目，3默认，4自定义商品
    addApp(type, app) {
      console.log("当前点击的", app);
      this.closeAll();
      this.fileList = [];
      this.goodsImg = [];
      this.currentApp = app;

      if (app.parentType == 200000) {
        this.goodsform = {
          parentItemId: app.ppCardItemId,
          itemType: 200010,
          platform: "1",
          itemTitle: "",
          itemSubtitle: "",
          itemLogo: "",
          outUrl: "",
          goodsMarketPrice: "",
          goodsPrice: "",
        };

        this.isShowGoodsSet = true;
      } else if (type == 1) {
        this.isShowCategory = true;
      } else if (type == 2) {
        this.zdyform = {
          parentItemId: app.ppCardItemId,
          itemType: 100010,
          itemTitle: "",
          outUrl: "",
          itemLogo: "",
        };

        this.isShowZDYSet = true;
      } else if (type == 3) {
        console.log("###", app.imageUrl);
        this.addform = {
          itemType: "",
          itemTitle: "",
          itemSubtitle: "",
          itemImage: "", //微信二维码
          outUrl: "", //大众点评才有
          shopActivityId: "",
          xhsItemTitle: "", //小红书标题

          sphId: "",
          sphVideoId: "",

          shopName: "",
          shopAddress: "",
          shopCategory: "",
          chatAiContentAgent: "",

          // 是否启用AI文案
          isEnableAi: 0,
          aiType: "",
          chatAihotSelling: "",
          chatAiContentMaxSize: "",
          chatAicopywritingTheme: "",
          chatAiContentRequirement: "",
          chatAiDishConfiguration: [],

          indexNum: 0,
          wifiName: "",
          password: "",

          outPoiId: "",
          outPoiName: "",
          outShopId: "",
          outShopName: "",

          lat: "",
          lon: "",
        };

        this.addform.itemType = app.type;
        this.addform.itemTitle = app.typeName;
        // this.addform.itemLogo = app.imageUrl;
        this.addform.shopName = this.shopForm.shopName;
        this.addform.shopAddress = this.shopForm.shopAddress;
        this.addform.outUrl = app.outUrl;
        this.addform.isEnableAi = app.isEnableAi;

        if (app.type == 180010) {
          this.isShowWifiSet = true;
        } else {
          this.isShowChildSet = true;
        }
      } else if (type == 4) {
        this.goodsform = {
          parentItemId: app.ppCardItemId,
          itemType: 200010,
          platform: "1",
          itemTitle: "",
          itemSubtitle: "",
          itemLogo: "",
          outUrl: "",
          goodsMarketPrice: "",
          goodsPrice: "",
        };

        this.isShowGoodsSet = true;
      }
    },
    // 添加子配置保存 type:1自定义 2默认
    // async addSave(type) {
    //   console.log("添加", type);
    //   if (type == 1) {
    //     if (this.categoryForm.itemTitle == "") {
    //       this.$message.error("请填写标题");
    //       return;
    //     }
    //     if (this.categoryForm.indexNum === "") {
    //       this.$message.error("请填写排序");
    //       return;
    //     }

    //     if (this.isIframe) {
    //       this.sendToParent({
    //         type: "addOrUpdatePpCardItem",
    //         data: Object.assign(this.categoryForm, {
    //           notifyType: "addSave1",
    //         }),
    //       });
    //     } else {
    //       const res = await addOrUpdatePpCardItem(this.categoryForm);
    //       if (res.code == 1) {
    //         await this.getModelList();
    //         this.$notify({
    //           title: "提示",
    //           message: "保存成功",
    //           type: "success",
    //           duration: 2000,
    //         });
    //         this.handleAddSave1();
    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     }
    //   } else if (type == 2) {
    //     if (this.zdyform.itemLogo == "") {
    //       this.$message.error("请上传图标");
    //       return;
    //     }
    //     if (this.zdyform.itemTitle == "") {
    //       this.$message.error("请填写标题");
    //       return;
    //     }
    //     if (this.zdyform.indexNum === "") {
    //       this.$message.error("请填写序号");
    //       return;
    //     }
    //     if (this.zdyform.outUrl == "") {
    //       this.$message.error("请填写外链");
    //       return;
    //     }

    //     const urlRegex = /^https?:\/\/.*$/;
    //     if (!urlRegex.test(this.zdyform.outUrl)) {
    //       this.$message.error("请输入正确的网址格式");
    //       return;
    //     }

    //     if (this.isIframe) {
    //       this.sendToParent({
    //         type: "addOrUpdatePpCardItem",
    //         data: Object.assign(this.zdyform, {
    //           notifyType: "addSave2",
    //         }),
    //       });
    //       this.handleAddSave2();
    //     } else {
    //       const res = await addOrUpdatePpCardItem(this.zdyform);
    //       if (res.code == 1) {
    //         await this.getModelList();

    //         this.$notify({
    //           title: "提示",
    //           message: "保存成功",
    //           type: "success",
    //           duration: 2000,
    //         });
    //         this.handleAddSave2();
    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     }
    //   } else if (type == 3) {
    //     if (
    //       this.addform.itemType == 150010 ||
    //       this.addform.itemType == 150040 ||
    //       this.addform.itemType == 150070 ||
    //       this.addform.itemType == 170010 ||
    //       this.addform.itemType == 170020 ||
    //       this.addform.itemType == 170030 ||
    //       this.addform.itemType == 170050
    //     ) {
    //       if (this.addform.outUrl == "" || this.addform.outUrl == undefined) {
    //         this.$message.error("请输入平台主页链接");
    //         return;
    //       }
    //       // const urlRegex = /^https?:\/\/.*$/;
    //       // if (!urlRegex.test(this.addform.outUrl) && this.addform.itemType) {
    //       //   this.$message.error("请输入正确的网址格式");
    //       //   return;
    //       // }
    //     }
    //     // if (this.addform.itemType == 150020) {
    //     //   if (!this.addform.outUrl) {
    //     //     this.$message.error("请输入抖音店铺poiid");
    //     //     return;
    //     //   }
    //     // }
    //     if (this.addform.itemType == 150080) {
    //       if (!this.addform.sphId) {
    //         this.$message.error("请输入视频号ID");
    //         return;
    //       }
    //       if (!this.addform.sphVideoId) {
    //         this.$message.error("请输入视频ID");
    //         return;
    //       }
    //     }
    //     if (this.addform.itemType == 170040) {
    //       if (!this.addform.sphId) {
    //         this.$message.error("请输入视频号ID");
    //         return;
    //       }
    //     }
    //     if (this.addform.itemType === 160020) {
    //       if (!this.addform.xhsItemTitle) {
    //         this.$message.error("请输入文案标题");
    //         return;
    //       }
    //     }
    //     if (
    //       this.addform.itemType === 160010 ||
    //       this.addform.itemType === 160020 ||
    //       this.addform.itemType === 160030 ||
    //       this.addform.itemType == 150010 ||
    //       this.addform.itemType == 150020 ||
    //       this.addform.itemType == 150030 ||
    //       this.addform.itemType == 150040 ||
    //       this.addform.itemType == 150050 ||
    //       this.addform.itemType == 150060 ||
    //       this.addform.itemType == 150070 ||
    //       this.addform.itemType == 140040
    //     ) {
    //       if (!this.addform.shopActivityId) {
    //         this.$message.error("请选择资源活动");
    //         return;
    //       }
    //     }
    //     if (this.addform.isEnableAi) {
    //       if (!this.addform.chatAihotSelling) {
    //         this.$message.error("请输入热销商品");
    //         return;
    //       }

    //       if (!this.addform.chatAiContentMaxSize) {
    //         this.$message.error("请选择文案字数");
    //         return;
    //       }

    //       if (!this.addform.chatAicopywritingTheme) {
    //         this.$message.error("请选择文案风格");
    //         return;
    //       }
    //     }
    //     if (this.addform.indexNum === "") {
    //       this.$message.error("请填写序号");
    //       return;
    //     }
    //     if (this.addform.itemType == 150030) {
    //       if (!this.addform.outPoiId) {
    //         this.$message.error("请输入poiid");
    //         return;
    //       }
    //       if (!this.addform.outPoiName) {
    //         this.$message.error("请输入poiName");
    //         return;
    //       }
    //       if (!this.addform.lat || !this.addform.lon) {
    //         this.$message.error("请选择位置");
    //         return;
    //       }
    //     }

    //     if (this.isIframe) {
    //       this.sendToParent({
    //         type: "addOrUpdatePpCardItem",
    //         data: Object.assign(this.addform, {
    //           notifyType: "addSave3",
    //         }),
    //       });
    //       this.handleAddSave3();
    //     } else {
    //       console.log(this.addform);
    //       try {
    //         const res = await addOrUpdatePpCardItem(this.addform);
    //         if (res.code == 1) {
    //           await this.getModelList();

    //           this.$notify({
    //             title: "提示",
    //             message: "保存成功",
    //             type: "success",
    //             duration: 2000,
    //           });
    //           this.handleAddSave3();
    //         } else {
    //           this.$message.error(res.msg);
    //         }
    //       } catch (error) {
    //         console.log(error);
    //       }
    //     }
    //   } else if (type == 4) {
    //     if (this.goodsform.itemLogo == "") {
    //       this.$message.error("请上传图标");
    //       return;
    //     }
    //     if (this.goodsform.itemTitle == "") {
    //       this.$message.error("请填写标题");
    //       return;
    //     }
    //     if (this.goodsform.indexNum === "") {
    //       this.$message.error("请填写序号");
    //       return;
    //     }

    //     if (this.goodsform.platform == 1) {
    //       if (this.goodsform.outUrl == "") {
    //         this.$message.error("请输入商品activeid");
    //         return;
    //       }
    //     } else {
    //       const urlRegex = /^https?:\/\/.*$/;
    //       if (!urlRegex.test(this.goodsform.outUrl)) {
    //         this.$message.error("请输入正确的商品链接");
    //         return;
    //       }
    //     }

    //     console.log(this.goodsform);

    //     if (this.isIframe) {
    //       this.sendToParent({
    //         type: "addOrUpdatePpCardItem",
    //         data: Object.assign(this.goodsform, {
    //           notifyType: "addSave4",
    //         }),
    //       });
    //       this.handleAddSave4();
    //     } else {
    //       const res = await addOrUpdatePpCardItem(this.goodsform);
    //       if (res.code == 1) {
    //         await this.getModelList();

    //         this.$notify({
    //           title: "提示",
    //           message: "保存成功",
    //           type: "success",
    //           duration: 2000,
    //         });
    //         this.handleAddSave4();
    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     }
    //   }
    // },

    async addSave(type) {
      console.log("添加", type);
      if (this.isSaving) {
        this.$message.error("请勿重复提交");
        return;
      }
      this.isSaving = true;
      const loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        if (type == 1) {
          if (this.categoryForm.itemTitle == "") {
            this.$message.error("请填写标题");
            return;
          }
          if (this.categoryForm.indexNum === "") {
            this.$message.error("请填写排序");
            return;
          }

          if (this.isIframe) {
            this.sendToParent({
              type: "addOrUpdatePpCardItem",
              data: Object.assign(this.categoryForm, {
                notifyType: "addSave1",
              }),
            });
          } else {
            const res = await addOrUpdatePpCardItem(this.categoryForm);
            if (res.code == 1) {
              await this.getModelList();
              this.$notify({
                title: "提示",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.handleAddSave1();
            } else {
              this.$message.error(res.msg);
            }
          }
        } else if (type == 2) {
          if (this.zdyform.itemLogo == "") {
            this.$message.error("请上传图标");
            return;
          }
          if (this.zdyform.itemTitle == "") {
            this.$message.error("请填写标题");
            return;
          }
          if (this.zdyform.indexNum === "") {
            this.$message.error("请填写序号");
            return;
          }
          if (this.zdyform.outUrl == "") {
            this.$message.error("请填写外链");
            return;
          }

          const urlRegex = /^https?:\/\/.*$/;
          if (!urlRegex.test(this.zdyform.outUrl)) {
            this.$message.error("请输入正确的网址格式");
            return;
          }

          if (this.isIframe) {
            this.sendToParent({
              type: "addOrUpdatePpCardItem",
              data: Object.assign(this.zdyform, {
                notifyType: "addSave2",
              }),
            });
            this.handleAddSave2();
          } else {
            const res = await addOrUpdatePpCardItem(this.zdyform);
            if (res.code == 1) {
              await this.getModelList();

              this.$notify({
                title: "提示",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.handleAddSave2();
            } else {
              this.$message.error(res.msg);
            }
          }
        } else if (type == 3) {
          if (
            this.addform.itemType == 150010 ||
            this.addform.itemType == 150040 ||
            this.addform.itemType == 150070 ||
            this.addform.itemType == 150090 ||
            this.addform.itemType == 170010 ||
            this.addform.itemType == 170020 ||
            this.addform.itemType == 170030 ||
            this.addform.itemType == 170050
          ) {
            if (this.addform.outUrl == "" || this.addform.outUrl == undefined) {
              this.$message.error("请输入平台主页链接");
              return;
            }
            // const urlRegex = /^https?:\/\/.*$/;
            // if (!urlRegex.test(this.addform.outUrl) && this.addform.itemType) {
            //   this.$message.error("请输入正确的网址格式");
            //   return;
            // }
          }
          // if (this.addform.itemType == 150020) {
          //   if (!this.addform.outUrl) {
          //     this.$message.error("请输入抖音店铺poiid");
          //     return;
          //   }
          // }
          if (this.addform.itemType == 150080) {
            if (!this.addform.sphId) {
              this.$message.error("请输入视频号ID");
              return;
            }
            if (!this.addform.sphVideoId) {
              this.$message.error("请输入视频ID");
              return;
            }
          }
          if (this.addform.itemType == 170040) {
            if (!this.addform.sphId) {
              this.$message.error("请输入视频号ID");
              return;
            }
          }
          if (this.addform.itemType === 160020) {
            if (!this.addform.xhsItemTitle) {
              this.$message.error("请输入文案标题");
              return;
            }
          }
          if (
            this.addform.itemType === 160010 ||
            this.addform.itemType === 160020 ||
            this.addform.itemType === 160030 ||
            this.addform.itemType == 150010 ||
            this.addform.itemType == 150020 ||
            this.addform.itemType == 150030 ||
            this.addform.itemType == 150040 ||
            this.addform.itemType == 150050 ||
            this.addform.itemType == 150060 ||
            this.addform.itemType == 150070 ||
            this.addform.itemType == 140040
          ) {
            if (!this.addform.shopActivityId) {
              this.$message.error("请选择资源活动");
              return;
            }
          }
          if (this.addform.isEnableAi) {
            if (!this.addform.chatAihotSelling) {
              this.$message.error("请输入热销商品");
              return;
            }

            if (!this.addform.chatAiContentMaxSize) {
              this.$message.error("请选择文案字数");
              return;
            }

            if (!this.addform.chatAicopywritingTheme) {
              this.$message.error("请选择文案风格");
              return;
            }
          }
          this.addform.chatAiDishConfiguration = JSON.stringify(
            this.addform.chatAiDishConfiguration
          );
          if (this.addform.indexNum === "") {
            this.$message.error("请填写序号");
            return;
          }
          if (this.addform.itemType == 150030) {
            if (!this.addform.outPoiId) {
              this.$message.error("请输入poiid");
              return;
            }
            if (!this.addform.outPoiName) {
              this.$message.error("请输入poiName");
              return;
            }
            if (!this.addform.lat || !this.addform.lon) {
              this.$message.error("请选择位置");
              return;
            }
          }

          if (this.isIframe) {
            this.sendToParent({
              type: "addOrUpdatePpCardItem",
              data: Object.assign(this.addform, {
                notifyType: "addSave3",
              }),
            });
            this.handleAddSave3();
          } else {
            console.log(this.addform);
            const res = await addOrUpdatePpCardItem(this.addform);
            if (res.code == 1) {
              await this.getModelList();

              this.$notify({
                title: "提示",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.handleAddSave3();
            } else {
              this.$message.error(res.msg);
            }
          }
        } else if (type == 4) {
          if (this.goodsform.itemLogo == "") {
            this.$message.error("请上传图标");
            return;
          }
          if (this.goodsform.itemTitle == "") {
            this.$message.error("请填写标题");
            return;
          }
          if (this.goodsform.indexNum === "") {
            this.$message.error("请填写序号");
            return;
          }

          if (this.goodsform.platform == 1) {
            if (this.goodsform.outUrl == "") {
              this.$message.error("请输入商品activeid");
              return;
            }
          } else {
            const urlRegex = /^https?:\/\/.*$/;
            if (!urlRegex.test(this.goodsform.outUrl)) {
              this.$message.error("请输入正确的商品链接");
              return;
            }
          }

          console.log(this.goodsform);

          if (this.isIframe) {
            this.sendToParent({
              type: "addOrUpdatePpCardItem",
              data: Object.assign(this.goodsform, {
                notifyType: "addSave4",
              }),
            });
            this.handleAddSave4();
          } else {
            const res = await addOrUpdatePpCardItem(this.goodsform);
            if (res.code == 1) {
              await this.getModelList();

              this.$notify({
                title: "提示",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.handleAddSave4();
            } else {
              this.$message.error(res.msg);
            }
          }
        }
      } finally {
        // 无论成功或失败都重置保存状态
        this.isSaving = false;
        loading.close();
      }
    },

    handleAddSave1() {
      this.isShowCategory = false;
      this.categoryForm = {
        itemType: 100000,
        itemTitle: "",
        indexNum: "",
        fontColor: "#000000",
      };
    },
    handleAddSave2() {
      this.isShowZDYSet = false;
      this.zdyform = { itemLogo: "", itemTitle: "", outUrl: "" };
    },
    handleAddSave3() {
      this.isShowChildSet = false;
      this.isShowWifiSet = false;
      this.addform = {
        itemType: "",
        itemTitle: "",
        itemSubtitle: "",
        itemImage: "", //微信二维码
        outUrl: "", //大众点评才有
        shopActivityId: "",
        xhsItemTitle: "", //小红书标题

        sphId: "",
        sphVideoId: "",

        shopName: "",
        shopAddress: "",
        shopCategory: "",
        chatAiContentAgent: "",

        // 是否启用AI文案
        isEnableAi: 0,
        aiType: "",
        chatAihotSelling: "",
        chatAiContentMaxSize: "",
        chatAicopywritingTheme: "",
        chatAiContentRequirement: "", // 保持原有值
        chatAiDishConfiguration: [],

        indexNum: 0,
        wifiName: "",
        password: "",

        outPoiId: "",
        outPoiName: "",
        outShopId: "",
        outShopName: "",

        lat: "",
        lon: "",
      };
    },
    handleAddSave4() {
      this.isShowGoodsSet = false;
      this.goodsform = {
        platform: "1",
        itemLogo: "",
        itemTitle: "",
        itemSubtitle: "",
        outUrl: "",
        indexNum: 0,
        goodsMarketPrice: 0,
        goodsPrice: 0,
      };
    },
    // 移除APP配置
    async deleteApp(app) {
      this.$confirm("确认是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async () => {
        try {
          if (this.isIframe) {
            this.sendToParent({
              type: "delPpCardId",
              data: { ppCardItemId: app.ppCardItemId },
            });
          } else {
            await delPpCardId({ ppCardItemId: app.ppCardItemId });
            await this.getModel3List();
            await this.getModelList();

            this.wxImageList = []; //清空微信图片

            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          }

          // this.isShowZDYSet = false;
          // this.isShowCategory = false;
          // this.isShowChildSet = false;
          this.closeAll();
        } catch (error) {
          this.$message.error(error);
        }
      });
    },
    // 编辑类目
    editCategory(app) {
      this.closeAll();

      this.categoryForm = Object.assign({ fontColor: "#000000" }, app);
      this.isShowCategory = true;
    },

    // 编辑
    handleEdit(app) {
      this.closeAll();
      this.fileList = [];
      this.wxImageList = [];

      console.log("正在编辑", app);
      // 若存在AI热销商品配置项目,则进行数组转化
      if (
        typeof app.chatAiDishConfiguration === "string" &&
        app.chatAiDishConfiguration
      ) {
        app.chatAiDishConfiguration = JSON.parse(app.chatAiDishConfiguration);
      } else if (Array.isArray(app.chatAiDishConfiguration)) {
        // 如果已经是数组，则不做改变
        app.chatAiDishConfiguration = app.chatAiDishConfiguration;
      } else {
        // 如果字段为空或其他类型，则设置为空数组
        app.chatAiDishConfiguration = [];
      }

      this.currentApp = app;
      this.mapCenterInputText = `${app.lon},${app.lat}`;

      if (app.itemType == 100010) {
        Object.assign(this.zdyform, app);
        if (this.zdyform.itemLogo) {
          this.fileList = [{ name: "", url: this.zdyform.itemLogo }];
        }
        this.isShowZDYSet = true;
      } else if (app.itemType == 180010) {
        Object.assign(this.addform, app);
        this.isShowWifiSet = true;
      } else {
        Object.assign(this.addform, app);
        if (this.addform.itemImage) {
          this.wxImageList = [{ url: this.addform.itemImage }];
        }
        this.isShowChildSet = true;
      }
    },
    editGoods(goods) {
      this.closeAll();
      this.goodsImg = [];

      this.goodsform = goods;
      console.log(this.goodsform);
      this.goodsImg = [{ name: "", url: this.goodsform.itemLogo }];
      this.isShowGoodsSet = true;
    },

    handleShow() {
      this.closeAll();
      this.isShowTitleSet = true;
    },

    handleShowImg(params) {
      this.currentSetImgIndex = params;

      this.group1Img = [];
      this.titleImgList[0].url &&
        this.group1Img.push({
          uid: Date.now(),
          url: this.titleImgList[0].url,
        });
      if (this.currentSetImgIndex > 0 && this.currentSetImgIndex < 5) {
        this.group2Img = [];
        this.fourImgList[params - 1].url &&
          this.group2Img.push(this.fourImgList[params - 1]);
      }

      this.closeAll();
      this.isShowImgSet = true;
    },

    handleShowImg2(params) {
      this.currentSetImgIndex2 = params;

      this.group3Img = [];
      this.threeImgList[params].url && this.group3Img.push(this.threeImgList[params]);

      this.closeAll();
      this.isShowImgSet2 = true;
    },

    saveImg() {
      // 保存
      const currentItem = this.titleImgList[0] || { url: "", outUrl: "" };
      this.titleImgList[0] = {
        url:
          this.group1Img && this.group1Img.length > 0 && this.group1Img[0]
            ? this.group1Img[0].url || ""
            : "",
        outUrl: currentItem.outUrl || "",
      };
      this.isShowImgSet = false;
      if (this.currentSetImgIndex > 0 && this.currentSetImgIndex < 5) {
        // 修复：正确的索引应该是 currentSetImgIndex - 1
        const targetIndex = this.currentSetImgIndex - 1;
        const currentItem = this.fourImgList[targetIndex] || { url: "", outUrl: "" };
        this.fourImgList[targetIndex] = {
          url:
            this.group2Img && this.group2Img.length > 0 && this.group2Img[0]
              ? this.group2Img[0].url || ""
              : "",
          outUrl: currentItem.outUrl || "",
        };
        this.isShowImgSet = false;
      } else {
        const targetIndex = this.currentSetImgIndex - 5;
        const currentItem = this.threeImgList[targetIndex] || { url: "", outUrl: "" };
        this.threeImgList[targetIndex] = {
          url:
            this.group3Img && this.group3Img.length > 0 && this.group3Img[0]
              ? this.group3Img[0].url || ""
              : "",
          outUrl: currentItem.outUrl || "",
        };
        this.isShowImgSet = false;
      }

      this.imagesObject = {
        titleImgList: this.titleImgList,
        fourImgList: this.fourImgList,
        threeImgList: this.threeImgList,
      };

      this.changeTab(4);
    },

    saveImg2() {
      // 保存
      // 获取当前项的原有数据，保留 outUrl
      const currentItem = this.threeImgList[this.currentSetImgIndex2] || {
        url: "",
        outUrl: "",
      };

      // 无论是否有新图片，都要确保对象结构完整
      this.threeImgList[this.currentSetImgIndex2] = {
        url:
          this.group3Img && this.group3Img.length > 0 && this.group3Img[0]
            ? this.group3Img[0].url || ""
            : "",
        outUrl: currentItem.outUrl || "",
      };

      this.isShowImgSet2 = false;

      this.imagesObject = {
        titleImgList: this.titleImgList,
        fourImgList: this.fourImgList,
        threeImgList: this.threeImgList,
      };

      this.changeTab(4);
    },

    // 关闭所有面板
    closeAll() {
      this.isShowCategory = false;
      this.isShowZDYSet = false;
      this.isShowTitleSet = false;
      this.isShowChildSet = false;
      this.isShowGoodsSet = false;
      this.isShowWifiSet = false;
      this.isShowImgSet = false;
      this.isShowImgSet2 = false;
    },

    // 保存
    async handleSave() {
      if (this.titleStyle == 0) {
        this.titleform.itemLogo = "";
        this.titleImg = [];
      } else {
        if (this.titleform.itemLogo == "") {
          this.$message.error("请上传背景图片");
          return;
        }
      }
      if (!this.titleform.fontColor) {
        this.titleform.fontColor = "#000000";
      }
      const httpData = {
        itemTitle: this.titleform.itemTitle,
        itemSubtitle: this.titleform.itemSubtitle,
        itemLogo: this.titleform.itemLogo,
        itemType: this.titleform.itemType,
        fontColor: this.titleform.fontColor,
        itemImages: this.titleform.itemImages,
        outUrl: "",
        templateType: this.tabsIndex + 1,
      };

      if (this.isSaving) {
        this.$message.error("操作正在进行中，请勿重复点击");
        return;
      }
      this.isSaving = true;
      const loading = this.$loading({
        lock: true,
        text: "正在保存中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        if (this.isIframe) {
          this.sendToParent({
            type: "addOrUpdatePpCardItem",
            data: Object.assign(httpData, {
              notifyType: "handleSave",
            }),
          });

          this.isSaving = false;
          loading.close();
        } else {
          console.log("进行添加操作");
          const res = await addOrUpdatePpCardItem(httpData);
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "保存成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      } catch (error) {
        this.$message.error(error);
      } finally {
        this.isSaving = false;
        loading.close();
      }
    },

    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG = file.type === "image/jpeg" || "image/png" || "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,PNG,JPEG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 3MB!");
      }
      return isJPG && isLt2M;
    },

    // 图片组
    handleSuccessGroup(res, params) {
      // 添加安全检查，确保 res 和 res.file 存在
      if (!res || !res.file) {
        console.error("无效的文件对象:", res);
        return;
      }

      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then((response) => {
          if (response.code == 1) {
            // 统一数据结构，确保所有图片组都使用相同的对象格式
            const imageData = {
              uid: Date.now(), // 生成唯一标识
              url: response.data.url,
            };

            if (params == 1) {
              // 设置顶部背景图
              this.group1Img.push(imageData);
            } else if (params == 2) {
              // 四拼图
              this.group2Img.push(imageData);
            } else if (params == 3) {
              // 三拼图
              this.group3Img.push(imageData);
            }
          } else {
            console.error("图片上传失败:", response.msg);
          }
        })
        .catch((error) => {
          console.error("图片上传异常:", error);
        });
    },

    handleRemoveGroup(file, fileList, params) {
      console.log("删除文件:", file, "参数:", params);

      // 根据参数确定要操作哪个图片组
      switch (params) {
        case 1:
          // 删除第一组图片中的对应项
          // 通过 uid 匹配（如果 file 是对象且有 uid）
          let index1;
          if (file.uid) {
            index1 = this.group1Img.findIndex((item) => item.uid === file.uid);
          } else {
            // 否则通过 url 匹配
            index1 = this.group1Img.findIndex((item) => item.url === (file.url || file));
          }

          console.log("index1", index1);
          if (index1 > -1) {
            this.group1Img.splice(index1, 1);
          }
          console.log(this.group1Img);
          break;
        case 2:
          // 删除第二组图片中的对应项
          let index2;
          if (file.uid) {
            index2 = this.group2Img.findIndex((item) => item.uid === file.uid);
          } else {
            index2 = this.group2Img.findIndex((item) => item.url === (file.url || file));
          }

          if (index2 > -1) {
            this.group2Img.splice(index2, 1);
          }
          break;
        case 3:
          // 删除第三组图片中的对应项
          let index3;
          if (file.uid) {
            index3 = this.group3Img.findIndex((item) => item.uid === file.uid);
          } else {
            index3 = this.group3Img.findIndex((item) => item.url === (file.url || file));
          }

          if (index3 > -1) {
            this.group3Img.splice(index3, 1);
          }
          break;
        default:
          console.warn("未知的图片组参数:", params);
      }
    },

    // 背景图上传
    handleSuccessImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.titleform.itemLogo = res.data.url;
        }
      });
    },
    handleRemove() {
      this.titleform.itemLogo = "";
      this.titleImg = [];
    },

    // 自定义图标上传
    handleSuccessImg1(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.zdyform.itemLogo = res.data.url;
        }
      });
    },
    handleRemove1() {
      this.zdyform.itemLogo = "";
    },

    // 商品图标上传
    handleSuccessImg2(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.goodsform.itemLogo = res.data.url;
        }
      });
    },
    handleRemove2() {
      this.goodsform.itemLogo = "";
    },

    // 微信二维码上传
    handleSuccessImg3(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.addform.itemImage = res.data.url;
        }
      });
    },
    handleRemove3() {
      this.addform.itemImage = "";
    },

    // 修改模板
    async changeTab(params) {
      console.log("当前模板", params);
      if (this.isSaving) {
        this.$message.error("请勿连续切换");
        return;
      }
      if (this.tabsIndex == params) return;
      this.isSaving = true;
      loading = this.$loading({
        lock: true,
        text: "加载中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const httpData = {
        itemTitle: this.titleform.itemTitle,
        itemSubtitle: this.titleform.itemSubtitle,
        itemLogo: this.titleform.itemLogo,
        cateringPosterTemp: JSON.stringify(this.imagesObject),
        itemType: this.titleform.itemType,
        fontColor: this.titleform.fontColor,
        itemImage: "",
        outUrl: "",
        templateType: params + 1,
      };
      if (this.isIframe) {
        this.sendToParent({
          type: "addOrUpdatePpCardItemNoNotify",
          data: Object.assign(httpData, {
            notifyType: "changeTab",
            params: params,
          }),
        });
      } else {
        try {
          const res = await addOrUpdatePpCardItem(httpData);
          if (res.code == 1) {
            this.tabsIndex = params;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.$message.error(error);
        } finally {
          this.isSaving = false;
          loading.close();
        }
      }
    },

    // 下面的3个方法为拖拽移动
    handleDragStart(itemType, index) {
      this.draggintItemType = itemType;
      this.draggingIndex = index;
    },
    handleDragEnd() {
      this.draggingIndex = null;
    },
    async handleDrop(type, list, dropIndex) {
      if (this.draggintItemType != type) return;
      if (this.draggingIndex === null || this.draggingIndex === dropIndex) return;

      // 交换draggingIndex和dropIndex位置
      const temp = list[this.draggingIndex];
      list[this.draggingIndex] = list[dropIndex];
      list[dropIndex] = temp;
      try {
        const tempArr = [list[dropIndex], list[this.draggingIndex]];
        tempArr.forEach((item) => {
          item.id = item.ppCardItemId;
        });

        if (this.isIframe) {
          this.sendToParent({
            type: "updatePpCardIdIndex",
            data: { ppCardItems: JSON.stringify(tempArr) },
          });
        } else {
          const res = await updatePpCardIdIndex({ ppCardItems: JSON.stringify(tempArr) });
          if (res.code == 1) {
            await this.getModelList();
          } else {
            this.$message.error(res.msg);
          }
        }
      } catch (error) {
        this.$message.error(error);
      }
    },

    addMenu(tag) {
      tag.type = tag.type === "success" ? "info" : "success";
    },

    handleClose(tag) {
      this.addform.chatAiDishConfiguration.splice(
        this.addform.chatAiDishConfiguration.indexOf(tag),
        1
      );
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue.trim();
      if (inputValue) {
        // 检查是否已存在同名商品（忽略大小写和首尾空格）
        const isDuplicate = this.addform.chatAiDishConfiguration.some(
          (item) => item.label.trim().toLowerCase() === inputValue.toLowerCase()
        );

        if (isDuplicate) {
          // 如果已存在同名商品，给出提示
          this.$message.warning("该商品已存在，请勿重复添加");
        } else {
          // 如果不存在同名商品，则添加
          this.addform.chatAiDishConfiguration.push({
            label: inputValue,
            type: "success",
          });
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  height: 100%;
}
.top {
  width: 100%;
  height: 40px;

  background-color: #f8f8f8;
}

.content {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.model-content {
  flex: 1;
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  padding: 20px 30px;
}

.qrcode-content {
  width: 379px;

  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  box-sizing: border-box;
  padding: 79px 32px;

  .link {
    width: 292px;
    height: 91px;
    background: rgba(240, 240, 240, 1);
    word-wrap: break-word;

    // box-sizing: border-box;
    // padding: 8px 10px;
  }

  .tip {
    font-size: 14px;
    color: rgba(224, 11, 111, 1);

    margin-top: 9px;
    margin-bottom: 60px;
  }

  .btn-list {
    display: flex;
    justify-content: space-between;

    .copy {
      width: 128px;
      height: 46px;

      text-align: center;
      line-height: 46px;
      font-size: 16px;
      color: rgba(0, 0, 0, 1);

      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(207, 207, 207, 1);

      cursor: pointer;
    }

    .download {
      width: 128px;
      height: 46px;

      text-align: center;
      line-height: 46px;
      color: #fff;

      background: rgba(64, 158, 255, 1);

      cursor: pointer;
    }
  }
}

// .ai-content {
//   position: relative;
//   width: 398px;

//   box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

//   &-title {
//     height: 65px;
//     background: linear-gradient(90deg, rgba(221, 250, 254, 1) 0%, rgba(255, 244, 255, 1) 100%);

//     font-size: 14px;
//     color: rgba(0, 0, 0, 1);

//     box-sizing: border-box;
//     padding: 15px 23px;
//   }

//   &-form {
//     border-radius: 12px 12px 0px 0px;
//     background: rgba(255, 255, 255, 1);

//     margin-top: -18px;

//     box-sizing: border-box;
//     padding: 20px 11px;

//     .form-text {
//       font-size: 14px;
//       color: rgba(0, 0, 0, 1);

//       margin-bottom: 5px;
//     }

//     .form-input {
//       display: flex;

//       border-radius: 12px;
//       background: rgba(255, 255, 255, 1);
//       box-sizing: border-box;
//       padding: 14px 13px;
//       border: 1px solid rgba(224, 224, 224, 1);

//       margin-bottom: 15px;

//       input {
//         flex: 1;

//         margin: 0;
//         padding: 0;
//         border: none;
//       }

//       input:focus {
//         border: none;
//         outline: none;
//       }
//     }
//   }

//   &-bottom {
//     position: absolute;
//     left: 0;
//     bottom: 0;

//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     width: 100%;

//     box-sizing: border-box;
//     padding: 60px 22px;

//     &-btn1 {
//       display: flex;
//       align-items: center;
//       justify-content: center;

//       width: 174px;
//       height: 46px;
//       border-radius: 23px;

//       font-size: 16px;
//       color: rgba(0, 0, 0, 1);

//       box-sizing: border-box;
//       border: 1px solid rgba(161, 161, 161, 1);
//     }

//     &-btn2 {
//       display: flex;
//       align-items: center;
//       justify-content: center;

//       width: 174px;
//       height: 46px;
//       border-radius: 23px;

//       font-size: 16px;
//       color: rgba(255, 255, 255, 1);

//       background: rgba(64, 158, 255, 1);
//     }
//   }
// }

.tabs {
  display: flex;
  width: 100%;

  margin-bottom: 20px;

  &-item {
    font-size: 14px;
    line-height: 20px;
    color: rgba(100, 103, 108, 1);

    border-bottom: 2px solid #fff;

    margin-right: 20px;

    box-sizing: border-box;
    padding-bottom: 3px;

    cursor: pointer;
  }

  .active {
    color: rgba(0, 0, 0, 1);
    border-bottom: 2px solid rgba(71, 122, 255, 1);
  }

  .look {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 86px;
    height: 30px;

    font-size: 12px;
    color: rgba(255, 255, 255, 1);

    border-radius: 4px;
    background: rgba(64, 158, 255, 1);

    margin-left: auto;
    cursor: pointer;

    &-text {
      width: 100%;
      height: 100%;
      line-height: 30px;
      text-align: center;
    }

    &-content {
      position: absolute;
      right: 0;
      top: 40px;

      // width: 202px;
      // height: 267px;

      font-size: 12px;
      color: rgba(0, 0, 0, 1);

      border-radius: 8px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

      padding: 16px 19px;

      &-title {
        margin-bottom: 9px;
      }

      &-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;

        margin-bottom: 9px;

        .copy {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 83px;
          height: 30px;
          background: rgba(255, 255, 255, 1);

          font-size: 12px;
          color: rgba(0, 0, 0, 1);

          box-sizing: border-box;
          border: 0.65px solid rgba(207, 207, 207, 1);

          margin-right: 4px;
        }

        .download {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 83px;
          height: 30px;
          background: rgba(64, 158, 255, 1);

          font-size: 12px;
          color: rgba(255, 255, 255, 1);
        }
      }

      .tips {
        font-size: 12px;
        color: rgba(224, 11, 111, 1);
      }
    }
  }
}

.first {
  position: relative;
  width: 300px;
  height: 576px;

  overflow-y: auto;
  box-sizing: border-box;
  padding: 43px 16px;
  margin-right: 48px;

  background-size: cover;

  &-bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    width: 100%;
    height: 100%;
  }

  .title-box {
    position: relative;
    width: 100%;
    height: 85px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    border-radius: 2px;

    border: 1px dashed rgba(157, 157, 158, 1);
    cursor: pointer;

    .title {
      font-size: 29px;
      color: #000000;
    }

    .subtitle {
      font-size: 13px;
      color: #000000;
    }
  }

  .img-box {
    width: 100%;

    margin-top: 18px;
    margin-bottom: 14px;

    border-radius: 12px;
    overflow: hidden;

    cursor: pointer;

    .upload-area {
      display: flex;
      justify-content: center;
      align-items: center;

      height: 118px;
      background: rgba(241, 241, 241, 1);

      img {
        width: 53px;
        height: 51px;
      }

      .upload-text {
        margin-left: 19px;

        &-title {
          font-size: 13px;
          color: rgba(157, 157, 158, 1);
        }

        &-subtitle {
          margin-top: 3px;

          width: 129px;
          font-size: 10px;
          color: rgba(157, 157, 158, 1);
        }
      }
    }

    .join {
      height: 115px;
      background: rgba(255, 255, 255, 1);

      box-sizing: border-box;
      padding: 18px;

      &-text1 {
        font-size: 13px;
        color: rgba(0, 0, 0, 1);
      }

      &-text2 {
        font-size: 10px;
        color: rgba(157, 157, 158, 1);

        margin-bottom: 10px;
      }

      &-btn {
        width: 100%;
        height: 36px;

        text-align: center;
        font-size: 13px;
        line-height: 36px;
        color: rgba(255, 255, 255, 1);

        border-radius: 20px;
        background: rgba(64, 158, 255, 1);
        margin: 0 auto;
      }
    }
  }

  .add-box {
    display: flex;
    align-items: center;

    height: 80px;
    border-radius: 5px;
    background: linear-gradient(0,
        rgba(243, 231, 233, 0.9) 0%,
        rgba(227, 238, 255, 0.9) 99%,
        rgba(227, 238, 255, 0.9) 100%);

    box-sizing: border-box;
    padding: 10px;

    cursor: pointer;

    margin: 14px 0;

    img {
      width: 48px;
      height: 48px;

      margin-right: 5px;
    }

    .font-text {
      // flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;

      &-1 {
        // width: 100%;
        // max-width: 146px;
        max-width: 190px;
        font-size: 20px;
        color: rgba(67, 79, 105, 1);

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &-2 {
        // width: 100%;
        // max-width: 146px;
        max-width: 190px;
        font-size: 16px;
        color: rgba(0, 0, 0, 1);

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    // &-btn {
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;

    //     width: 50px;
    //     height: 18px;
    //     border-radius: 93px;
    //     background: rgba(204, 221, 252, 1);

    //     font-size: 10px;

    //     margin-left: auto;

    //     span {
    //         width: 29px;

    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         overflow: hidden;
    //     }
    // }
  }

  .app-box-type-1 {
    position: relative;
    width: 100%;

    margin-top: 10px;

    cursor: pointer;

    .app-list {
      display: flex;
      flex-wrap: wrap;

      margin: 0 -5px;

      .app-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        width: 29%;
        height: 115px;

        background: rgba(255, 255, 255, 1);
        border-radius: 12px;

        box-sizing: border-box;
        padding: 5px;

        margin: 0 5px 10px;

        &-img {
          width: 34px;
          height: 34px;

          margin-top: 23px;
          margin-bottom: 12px;
        }

        &-text1 {
          width: 100%;
          text-align: center;
          font-size: 11px;
          color: rgba(0, 0, 0, 1);

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          margin-bottom: 2px;
        }

        &-text2 {
          width: 100%;

          text-align: center;
          font-size: 8px;
          color: rgba(157, 157, 158, 1);

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .app-box-type-2 {
    position: relative;
    width: 100%;

    margin-top: 17px;

    cursor: pointer;

    .app-item {
      display: flex;
      align-items: center;

      height: 85px;

      background-color: #fff;
      border-radius: 12px;

      box-sizing: border-box;
      padding: 22px 20px;

      margin-top: 14px;

      img {
        width: 42px;
        height: 42px;

        margin-right: 13px;
      }

      &-text1 {
        width: 170px;
        font-size: 16px;
        color: rgba(0, 0, 0, 1);

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &-text2 {
        width: 170px;
        font-size: 11px;
        color: rgba(157, 157, 158, 1);

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        margin-top: 2px;
      }
    }
  }

  .app-box-type-3 {
    position: relative;
    cursor: pointer;

    .app-list {
      margin: 0 -3.5px;
    }

    .app-title {
      margin: 10px 0;
    }

    .app-item {
      width: 30%;
      height: 54px;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      border-radius: 3px;
      background-color: #fff;

      margin: 0 3.5px 7px;

      &-img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }

      &-text {
        width: 100%;

        text-align: center;
        font-size: 9px;
        color: rgba(0, 0, 0, 1);

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        margin-top: 3px;
      }
    }
  }

  .goods-list {
    box-sizing: border-box;
    padding: 9px 15px;

    background-color: #fff;
    border-radius: 13px;

    margin-top: 10px;

    &-title {
      font-size: 16px;
      font-weight: 700;
      color: rgba(0, 0, 0, 1);

      margin-bottom: 10px;
    }

    :last-child {
      margin-bottom: 0;
    }

    &-item {
      display: flex;

      margin-bottom: 30px;

      .goods-img {
        width: 83px;
        height: 83px;

        border-radius: 9px;

        margin-right: 10px;
      }

      .goods-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        width: 100%;

        &-title {
          font-size: 14px;
          font-weight: 700;
          color: rgba(0, 0, 0, 1);
        }

        &-subtitle {
          font-size: 12px;
          color: rgba(157, 157, 158, 1);
        }

        &-price {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .goods-price1 {
            font-size: 12px;
            font-weight: 700;
            color: rgba(232, 72, 9, 1);
          }

          .goods-price2 {
            font-size: 12px;
            text-decoration-line: line-through;
            color: rgba(199, 199, 199, 1);
          }

          .goods-btn {
            width: 56px;
            height: 27px;

            text-align: center;
            line-height: 27px;
            color: #fff;
            font-size: 13px;

            border-radius: 200px;
            background: rgba(232, 72, 9, 1);
          }
        }
      }
    }
  }
}

.model4 {
  position: relative;
  width: 300px;
  height: 576px;

  overflow-y: auto;
  box-sizing: border-box;
  margin-right: 48px;

  background-size: cover;

  &-title {
    height: 128px;

    background: url("../assets/img/common/bg1.png") no-repeat;
    background-size: cover;

    box-sizing: border-box;
    padding: 17px 11px;

    .title {
      font-size: 20px;
      font-weight: 700;
    }

    .subtitle {
      font-size: 11px;
      margin: 6px 0;
    }

    .shop {
      width: 147px;
      height: 28px;

      display: flex;
      align-items: center;

      border-radius: 14px;
      background: rgba(255, 255, 255, 0.8);

      box-sizing: border-box;
      padding: 4px 9px;

      &-img {
        width: 24px;
        height: 20px;

        margin-right: 8px;
      }

      &-text {
        flex: 1;

        font-size: 10px;
        color: rgba(67, 79, 105, 1);

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .app-box-type-4 {
    position: relative;
    cursor: pointer;

    padding: 0 10px;
    margin-top: -18px;

    .app-list {
      // margin: 0 -3.5px;
      border-radius: 15px;
      background: rgba(255, 255, 255, 0.9);

      box-sizing: border-box;
      padding: 10px 13px 0 13px;

      margin-bottom: 10px;
    }

    .app-title {
      font-size: 13px;
      font-weight: 700;

      margin-bottom: 12px;
    }

    .app-item {
      width: 25%;

      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      margin-bottom: 17px;

      &-img {
        width: 30px;
        height: 30px;
        border-radius: 50%;

        margin-bottom: 7px;
      }

      &-text {
        width: 100%;

        text-align: center;
        font-size: 10px;
        color: rgba(0, 0, 0, 1);

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .goods-list {
    box-sizing: border-box;
    padding: 7px 13px;

    background: rgba(255, 255, 255, 0.8);
    border-radius: 11px;

    margin-top: 8px;

    &-title {
      font-size: 13px;
      font-weight: 700;
      color: rgba(0, 0, 0, 1);

      margin-bottom: 10px;
    }

    :last-child {
      margin-bottom: 0;
    }

    &-item {
      display: flex;

      padding-bottom: 10px;
      border-bottom: 0.5px solid rgba(227, 227, 227, 0.8);

      margin-bottom: 13px;

      &:last-child {
        border-bottom: none;
      }

      .goods-img {
        width: 66px;
        height: 66px;

        border-radius: 7px;

        margin-right: 10px;
      }

      .goods-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        width: 100%;

        &-title {
          font-size: 14px;
          font-weight: 700;
          color: rgba(0, 0, 0, 1);
        }

        &-subtitle {
          font-size: 12px;
          color: rgba(157, 157, 158, 1);
        }

        &-price {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .goods-price1 {
            font-size: 12px;
            font-weight: 700;
            color: rgba(232, 72, 9, 1);
          }

          .goods-price2 {
            font-size: 12px;
            text-decoration-line: line-through;
            color: rgba(199, 199, 199, 1);
          }

          .goods-btn {
            width: 56px;
            height: 27px;

            text-align: center;
            line-height: 27px;
            color: #fff;
            font-size: 13px;

            border-radius: 200px;
            background: rgba(232, 72, 9, 1);
          }
        }
      }
    }
  }
}

.model5 {
  position: relative;
  width: 300px;
  height: 576px;

  overflow-y: auto;
  box-sizing: border-box;
  margin-right: 48px;

  background-size: cover;

  &-title {
    height: 150px;

    // background: url("../assets/img/common/bg1.png") no-repeat;
    // background-size: cover;

    box-sizing: border-box;
    padding: 49px 11px 0;

    .title {
      font-size: 24px;
      font-weight: 700;
    }

    .shop {
      width: 147px;
      height: 37px;

      display: flex;
      align-items: center;

      margin-top: 15px;

      &-img {
        width: 37px;
        height: 37px;

        margin-right: 12px;

        border-radius: 50%;
      }

      &-text {
        flex: 1;

        font-size: 15px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .app-box-type-5 {
    position: relative;
    cursor: pointer;

    padding: 0 10px;

    .four-img {
      display: flex;
      margin: 10px 0;

      &-box {
        width: 25%;
        height: 150px;

        box-sizing: border-box;
        padding: 0 2px;

        border-radius: 4px;

        &-item {
          width: 100%;
          height: 150px;

          display: flex;
          align-items: center;
          justify-content: center;

          border: 1px dashed #cccccc;
        }

        &-img {
          width: 100%;
          height: 150px;

          border-radius: 10px;
        }
      }
    }

    .app-list {
      // margin: 0 -3.5px;
      border-radius: 15px;
      background: rgba(255, 255, 255, 0.9);

      box-sizing: border-box;
      padding: 10px 13px 0 13px;

      margin-bottom: 10px;
    }

    .three-img {
      .three-img-top {
        &-box {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 100%;
          height: 180px;
          border: 1px dashed #cccccc;
          border-radius: 5px;

          overflow: hidden;
        }

        &-img {
          width: 100%;
          height: 180px;

          border-radius: 5px;
        }
      }

      .three-img-bottom {
        .i-box {
          display: flex;
          margin: 5px -5px 0;

          &-item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;

            box-sizing: border-box;
            margin: 0 5px;

            &-img {
              width: 100%;
              height: 130px;

              border-radius: 5px;
            }

            &-empty {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 130px;
              border: 1px dashed #cccccc;

              border-radius: 5px;
            }

            i {
              flex: 1;
            }
          }
        }
      }
    }

    .app-title {
      font-size: 13px;
      font-weight: 700;

      margin-bottom: 12px;
    }

    .app-item {
      width: 25%;

      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      margin-bottom: 10px;

      &-img {
        width: 30px;
        height: 30px;
        border-radius: 50%;

        margin-bottom: 7px;
      }

      &-text {
        width: 100%;

        text-align: center;
        font-size: 10px;
        color: rgba(0, 0, 0, 1);

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .goods-list {
    box-sizing: border-box;
    padding: 7px 13px;

    background: rgba(255, 255, 255, 0.8);
    border-radius: 11px;

    margin-top: 8px;

    &-title {
      font-size: 13px;
      font-weight: 700;
      color: rgba(0, 0, 0, 1);

      margin-bottom: 10px;
    }

    :last-child {
      margin-bottom: 0;
    }

    &-item {
      display: flex;

      padding-bottom: 10px;
      border-bottom: 0.5px solid rgba(227, 227, 227, 0.8);

      margin-bottom: 13px;

      &:last-child {
        border-bottom: none;
      }

      .goods-img {
        width: 66px;
        height: 66px;

        border-radius: 7px;

        margin-right: 10px;
      }

      .goods-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        width: 100%;

        &-title {
          font-size: 14px;
          font-weight: 700;
          color: rgba(0, 0, 0, 1);
        }

        &-subtitle {
          font-size: 12px;
          color: rgba(157, 157, 158, 1);
        }

        &-price {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .goods-price1 {
            font-size: 12px;
            font-weight: 700;
            color: rgba(232, 72, 9, 1);
          }

          .goods-price2 {
            font-size: 12px;
            text-decoration-line: line-through;
            color: rgba(199, 199, 199, 1);
          }

          .goods-btn {
            width: 56px;
            height: 27px;

            text-align: center;
            line-height: 27px;
            color: #fff;
            font-size: 13px;

            border-radius: 200px;
            background: rgba(232, 72, 9, 1);
          }
        }
      }
    }
  }
}

.title-set {
  display: flex;
  flex-direction: column;

  width: 355px;
  height: 579px;

  border-radius: 8px;

  background: rgba(255, 255, 255, 1);

  box-sizing: border-box;
  padding: 24px;
  border: 1px solid rgba(212, 212, 212, 1);

  .title-form {
    // display: flex;

    &-item {
      display: flex;

      margin-bottom: 32px;

      &-left {
        width: 64px;

        font-size: 16px;
        line-height: 23px;
        color: rgba(0, 0, 0, 1);

        margin-right: 40px;
      }

      &-right {
        flex: 1;
        display: flex;

        .option-item {
          font-size: 16px;
          line-height: 24px;
          color: rgba(157, 157, 158, 1);

          box-sizing: border-box;
          padding: 2px 18px;
          border-radius: 2px;
          border: 0.5px solid rgba(157, 157, 158, 1);

          margin-right: 16px;

          cursor: pointer;
        }

        .active {
          color: rgba(64, 158, 255, 1);
          border: 0.5px solid rgba(64, 158, 255, 1);
        }

        .tips {
          color: rgba(157, 157, 158, 1);
          margin-top: 20px;
        }
      }
    }
  }

  &-save {
    width: 192px;
    height: 46px;

    text-align: center;
    line-height: 46px;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);

    border-radius: 23px;
    background: rgba(64, 158, 255, 1);

    margin: auto auto 0;

    cursor: pointer;
  }
}

.app-set {
  width: 355px;
  max-height: 579px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);

  border: 1px solid rgba(212, 212, 212, 1);

  margin-left: 15px;

  overflow-y: auto;
  flex-shrink: 0;

  .def-title {
    display: flex;
    align-items: center;

    font-size: 14px;
    line-height: 23px;
    color: rgba(255, 255, 255, 1);

    box-sizing: border-box;
    padding: 12px 22px;
    background: #000;

    .icon-edit {
      width: 12px;
      height: 12px;

      margin-left: 10px;
      margin-top: -3px;
    }

    .add {
      display: flex;
      align-items: center;

      margin-left: auto;

      cursor: pointer;

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

      &-text {
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }

  &-title {
    height: 45px;

    font-size: 16px;
    line-height: 45px;
    color: rgba(102, 102, 102, 1);

    background: rgba(219, 219, 219, 1);

    box-sizing: border-box;
    padding: 5px 22px;
  }

  .list {
    overflow: hidden;

    &-title {
      display: flex;
      align-items: center;

      font-size: 14px;
      line-height: 23px;
      color: rgba(255, 255, 255, 1);

      box-sizing: border-box;
      padding: 12px 22px;
      background: #000;

      .icon-edit {
        width: 12px;
        height: 12px;

        margin-left: 10px;
        margin-top: -3px;
      }

      .icon {
        width: 20px;
        height: 20px;

        margin-left: auto;
      }

      .add {
        display: flex;
        align-items: center;

        margin-left: auto;

        cursor: pointer;

        .icon {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }

        &-text {
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
        }
      }
    }

    &-item {
      display: flex;
      align-items: center;

      font-size: 16px;
      color: rgba(0, 0, 0, 1);

      box-sizing: border-box;
      padding: 17px 23px;

      border-bottom: 0.5px solid rgba(237, 237, 237, 1);

      .icon {
        width: 20px;
        height: 20px;

        margin-right: 17px;
      }

      .app-img {
        width: 25px;
        height: 25px;

        margin-right: 8px;
      }

      .app-name {
        width: 200px;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .move {
        margin-left: auto;

        &-img {
          width: 16px;
          height: 12px;
        }
      }

      .move[draggable="true"] {
        cursor: grab;
      }

      .move[draggable="true"]:active {
        cursor: grabbing;
      }
    }
  }
}

.child-set {
  width: 380px;
  min-height: 579px;

  border-radius: 8px;
  background: rgba(255, 255, 255, 1);

  box-sizing: border-box;
  padding-bottom: 24px;
  border: 1px solid rgba(212, 212, 212, 1);

  margin-left: 16px;

  &-item {
    display: flex;
    align-items: center;

    box-sizing: border-box;
    padding: 8px 30px;

    &-title {
      width: 80px;

      font-size: 16px;
      line-height: 23px;
      color: rgba(0, 0, 0, 1);

      margin-right: 36px;
    }

    &-right {
      flex: 1;
      display: flex;

      .option-item {
        font-size: 16px;
        line-height: 24px;
        color: rgba(157, 157, 158, 1);

        box-sizing: border-box;
        padding: 2px 18px;
        border-radius: 2px;
        border: 0.5px solid rgba(157, 157, 158, 1);

        margin-right: 16px;

        cursor: pointer;
      }

      .active {
        color: rgba(64, 158, 255, 1);
        border: 0.5px solid rgba(64, 158, 255, 1);
      }

      .tips {
        color: rgba(157, 157, 158, 1);
        margin-top: 20px;
      }
    }

    &-add {
      width: 58px;
      height: 28px;

      text-align: center;
      font-size: 14px;
      line-height: 28px;
      color: rgba(255, 255, 255, 1);

      border-radius: 2px;
      background: rgba(64, 158, 255, 1);

      margin-left: auto;
    }
  }

  &-dazhong {
    display: flex;
    flex-direction: column;

    box-sizing: border-box;
    padding: 5px 30px;

    &-title {
      font-size: 16px;
      color: rgba(0, 0, 0, 1);

      margin-bottom: 5px;
    }

    .text-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .switch-box {
      display: flex;
      align-items: center;

      font-size: 14px;
      background: -webkit-linear-gradient(122.68deg,
          rgba(201, 40, 145, 1) 0%,
          rgba(155, 105, 255, 1) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;

      div {
        margin-right: 5px;
      }
    }
  }

  &-xiecheng {
    display: flex;
    align-items: center;

    box-sizing: border-box;
    padding: 8px 30px;

    &-text {
      width: 80px;

      font-size: 16px;
      color: rgba(0, 0, 0, 1);

      margin-right: 36px;
    }

    &-right {
      flex: 1;
    }

    &-location {
      flex: 1;
      height: 40px;

      display: flex;
      align-items: center;

      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      border-radius: 10px;

      .key {
        width: 130px;

        box-sizing: border-box;
        padding: 0 10px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .btn {
        cursor: pointer;
        color: #909399;

        box-sizing: border-box;
        padding: 0 10px;

        border-left: 1px solid #dcdfe6;
      }
    }
  }

  .ai-condition {
    &-item {
      display: flex;
      align-items: center;

      box-sizing: border-box;
      padding: 5px 0;

      &-text {
        width: 80px;

        font-size: 16px;
        color: rgba(0, 0, 0, 1);

        margin-right: 36px;
      }

      &-right {
        flex: 1;
      }
    }
  }

  .default-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-bottom: 10px;

    &-left {
      font-size: 16px;
      color: rgba(0, 0, 0, 1);
    }

    &-right {
      display: flex;
      align-items: center;

      font-size: 14px;
      line-height: 20px;
      background: -webkit-linear-gradient(122.68deg,
          rgba(201, 40, 145, 1) 0%,
          rgba(155, 105, 255, 1) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;

      cursor: pointer;

      img {
        width: 13px;
        height: 13px;

        margin-right: 5px;
      }

      .rotate {
        animation: rotate-animation 1s linear infinite;
        transform-origin: center;
      }

      @keyframes rotate-animation {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(360deg);
        }
      }
    }
  }

  .shopInfo {
    font-size: 16px;
    line-height: 23px;
    color: rgba(0, 0, 0, 1);

    box-sizing: border-box;
    padding: 14px 30px;

    border-bottom: 0.5px solid rgba(237, 237, 237, 1);
  }

  &-save {
    width: 192px;
    height: 46px;

    text-align: center;
    line-height: 46px;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);

    border-radius: 23px;
    background: rgba(64, 158, 255, 1);

    margin: 0px auto 0;

    cursor: pointer;
  }

  &-apply {
    width: 192px;
    height: 46px;

    text-align: center;
    line-height: 46px;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);

    border-radius: 23px;
    background: rgba(64, 158, 255, 1);

    margin: 20px auto 0;

    cursor: pointer;
  }

  .pay-item {
    box-sizing: border-box;
    padding: 16px 30px;

    &-title {
      font-size: 16px;
      color: rgba(157, 157, 158, 1);

      margin-bottom: 12px;
    }

    &-container {
      display: flex;

      &-text {
        font-size: 16px;
        color: rgba(0, 0, 0, 1);
      }

      &-btn {
        width: 76px;
        height: 26px;

        text-align: center;
        line-height: 26px;
        font-size: 12px;
        color: rgba(255, 255, 255, 1);

        border-radius: 4px;
        background: rgba(64, 158, 255, 1);

        margin-left: auto;

        cursor: pointer;
      }
    }
  }

  textarea {
    // width: 295px;
    width: 100%;
    height: 70px;

    border-radius: 12px;
    background: rgba(247, 247, 247, 1);

    resize: none;
  }
}

.img-set {
  display: flex;
  flex-direction: column;

  width: 355px;
  height: 579px;

  border-radius: 8px;

  background: rgba(255, 255, 255, 1);

  box-sizing: border-box;
  padding: 24px;
  border: 1px solid rgba(212, 212, 212, 1);

  margin-left: 15px;

  .img-form {
    &-item {
      display: flex;

      margin-bottom: 32px;

      &-left {
        font-size: 16px;
        line-height: 23px;
        color: rgba(0, 0, 0, 1);
      }

      &-right {
        flex: 1;
        display: flex;

        .option-item {
          font-size: 16px;
          line-height: 24px;
          color: rgba(157, 157, 158, 1);

          box-sizing: border-box;
          padding: 2px 18px;
          border-radius: 2px;
          border: 0.5px solid rgba(157, 157, 158, 1);

          margin-right: 16px;

          cursor: pointer;
        }

        .active {
          color: rgba(64, 158, 255, 1);
          border: 0.5px solid rgba(64, 158, 255, 1);
        }

        .tips {
          color: rgba(157, 157, 158, 1);
          margin-top: 20px;
        }
      }
    }

    &-textarea {
      width: 100%;
      height: 70px;
      border-radius: 12px;
      background: #f7f7f7;
      resize: none;
    }
  }
}

.map {
  width: 100%;
  height: 400px;

  :deep(.anchorBL) {
    display: none;
  }
}
</style>

<style lang="less" scoped>
:deep(.el-upload--picture-card) {
  width: 84px;
  height: 84px;

  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 84px;
  height: 84px;
}

input {
  flex: 1;
  height: 24px;
  line-height: 24px;

  padding: 0;
  margin: 0;
  border: none;

  font-size: 16px;
}

.hide .el-upload {
  display: none;
}

:deep(.el-radio-button__inner) {
  padding: 12px;
}

:deep(.el-tag) {
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>
